const defaultGermanMessages = {
  date: {
    defaultDateFormat: "dd.MM.yyyy",
    defaultDateTimeFormat: "dd.MM.yyyy kk:mm:ss",
    dateInputPattern: "##.##.####",
  },
  ra: {
    action: {
      add_filter: "Add filter",
      add_price_position: "Add position",
      add: "Add",
      accept: "Accept",
      back: "Back",
      bulk_actions: "One item selected |||| %{smart_count} items selected",
      cancel: "Cancel",
      clear_input_value: "Clear input",
      clear_array_input: "Clear list input",
      clone: "Clone",
      close: "Close",
      close_menu: "Close menu",
      confirm: "Confirm",
      create: "Create",
      create_item: "Create item",
      delete: "Delete",
      download: "Download",
      edit: "Edit",
      expand: "Expand",
      export: "Export",
      list: "List",
      move_down: "Move down",
      move_up: "Move up",
      open: "Open",
      open_menu: "Open menu",
      reset: "Reset",
      refresh: "Refresh",
      remove_filter: "Remove filter",
      remove_all_filters: "Remove all filters",
      remove: "Remove",
      save: "Save",
      search: "Search",
      search_columns: "Search columns",
      select_all: "Select all",
      select_all_button: "Select all",
      select_row: "Select entry",
      select_columns: "Columns",
      send: "Send",
      show: "Show",
      sort: "Sort",
      toggle_theme: "Change theme",
      undo: "Undo",
      unselect: "Unselect",
      update: "Update",
      update_application: "Update application",
    },
    boolean: {
      true: "Yes",
      false: "No",
      null: " ",
    },
    page: {
      list: "%{name}",
      edit: "%{name} #%{id}",
      show: "%{name} #%{id}",
      create: "Create %{name}",
      loading: "Loading",
      dashboard: "Dashboard",
      not_found: "Not found",
      error: "Something went wrong",
      empty: "Nothing here yet.",
      invite: "Want to make some changes?",
      access_denied: "Access denied",
      authentication_error: "Authentication error",
    },
    sort: {
      ASC: "ascending",
      DESC: "descending",
      sort_by: "%{field}",
    },
    input: {
      file: {
        upload_several: "Drag and drop files to upload or click here to select files.",
        upload_single: "Drag and drop a file to upload or click here to select a file.",
      },
      image: {
        upload_several: "Drag and drop images to upload or click here to select images.",
        upload_single: "Drag and drop an image to upload or click here to select an image.",
      },
      password: {
        toggle_visible: "Hide password",
        toggle_hidden: "Show password",
      },
      references: {
        all_missing: "The related references could not be found.",
        many_missing: "At least one of the related references no longer seems to be available.",
        single_missing: "A related reference no longer seems to be available.",
      },
    },
    message: {
      yes: "Yes",
      no: "No",
      are_you_sure: "Are you sure?",
      about: "About",
      auth_error: "Please log in to continue",
      not_found: "The page could not be found.",
      loading: "The page is loading.",
      invalid_form: "The form is invalid. Please check your entries.",
      delete_title: "Delete",
      delete_content: "Do you really want to delete this content?",
      bulk_delete_title: "Confirm Deletion",
      bulk_delete_content:
        "Do you really want to delete this item? |||| Do you really want to delete these %{smart_count} items?",
      bulk_update_content: "Do you really want to update this item? |||| Really update these %{smart_count} items?",
      bulk_update_title: "Confirm Update",
      clear_array_input: "Do you really want to delete the entire list?",
      details: "Details",
      error: "An error occurred and your request could not be completed.",
      unsaved_changes: "Some changes were not saved. Really ignore?",
      delete_failed_must_archive: "Deletion not possible, please archive.",
      access_denied: "Access Denied",
      authentication_error: "Authentication Error",
      select_all_limit_reached: "Maximum number for selection reached",
      placeholder_data_warning: "Network issue: Data refresh failed.",
    },
    navigation: {
      no_results: "None available yet",
      no_more_results: "Page %{page} has no content.",
      page_out_of_boundaries: "Page %{page} is out of valid range",
      page_out_from_end: "Last Page",
      page_out_from_begin: "First Page",
      page_range_info: "%{offsetBegin}-%{offsetEnd} of %{total}",
      page_rows_per_page: "Rows per page:",
      next: "Next",
      prev: "Back",
      previous: "Back",
      skip_nav: "Skip to content",
      partial_page_range_info: "%{offsetBegin}-%{offsetEnd} of more than %{offsetEnd}",
      current_page: "Page %{page}",
      page: "Page %{page}",
      first: "First Page",
      last: "Last Page",
      no_filtered_results: "No results found for these filters.",
      clear_filters: "Reset all filters",
    },
    auth: {
      auth_check_error: "Please log in to continue",
      user_menu: "Profile",
      username: "Email",
      email: "Email",
      password: "Password",
      sign_in: "Sign In",
      sign_in_error: "Sign In Error",
      logout: "Log Out",
    },
    notification: {
      i18n_error: "Translations for the selected language not available.",
      not_authorized: "You do not have access to this content.",
      updated: "Element updated |||| %{smart_count} elements updated",
      created: "Element created",
      deleted: "Element deleted |||| %{smart_count} elements deleted",
      bad_item: "Faulty element",
      item_doesnt_exist: "The element does not exist",
      http_error: "Error communicating with the server",
      data_provider_error: "dataProvider error. Check the console for details.",
      canceled: "Action canceled",
      logged_out: "You have been logged out. Please log in again.",
      application_update_available: "Update available",
      offline: "Offline",
    },
    validation: {
      required: "Required",
      minLength: "Must be at least %{min} characters",
      maxLength: "Must be no more than %{max} characters",
      minValue: "Must be at least %{min}",
      maxValue: "Must be %{max} or less",
      number: "Must be a number",
      email: "Must be a valid email",
      oneOf: "Must be one of: %{options}",
      regex: "Must match the following regular expression: %{pattern}",
      not_unique: "is already used",
      unique: "Must be unique",
    },
    saved_queries: {
      label: "Saved filters",
      query_name: "Filter name",
      new_label: "Save current filter...",
      new_dialog_title: "Save current filter as",
      remove_label: "Remove saved filter",
      remove_label_with_name: 'Remove saved filter "%{name}"',
      remove_dialog_title: "Remove saved filter?",
      remove_message: "Are you sure you want to delete this entry from your list of saved filters?",
      help: "Filter list and save filter setting",
    },
    configurable: {
      customize: "Customize",
      templateError: "## Template error",
      configureMode: "Configure this page",
      inspector: {
        title: "Inspector",
        content: "Point at application elements to customize them",
        reset: "Reset settings",
        hideAll: "Hide all",
        showAll: "Show all",
      },
      SimpleList: {
        title: "List",
        primaryText: "Primary text",
        secondaryText: "Secondary text",
        tertiaryText: "Tertiary text",
      },
      Datagrid: {
        title: "Data Table",
        unlabeled: "Unnamed Column #%{column}",
      },
      SimpleForm: {
        title: "Form",
        unlabeled: "Unnamed Field #%{input}",
      },
    },
  },
};
const userFields = {
  id: "ID",
  image_path: "Image path",
  lecturer_fee: "Fee",
  user_custom_fields_data: "Custom Fields",
  is_unverified: "Unverified",
  guest: "Guest",
  title: "Title",
  first_name: "First Name",
  last_name: "Last Name",
  full_name: "Full Name",
  gender: "Gender",
  birthday: "Date of Birth",
  address: "Address",
  main_contact_info: "Communication",
  invoice_contact_info: "Invoice",
  invoice_dispatch_contact_info: "Invoice Dispatch",
  main_contact_info__email: "Email (Communication)",
  main_contact_info__organization_name: "Organization Name (Communication)",
  main_contact_info__city: "City (Communication)",
  main_contact_info__postcode: "Postcode (Communication)",
  login_email: "Login Email",
  auth_user__email: "Login Email",
  lecturer__common_fee: "Fee (€)",
  attendee__attendee_number: "Customer Number",
  contact_types: "Type of Contact Information",
  debit_number: "Debtor Number",
  audience_role: "Audience",
  common_fee: "Fee (€)",
  description: "Description",
  qualifications: "Qualifications",
  categories: "Categories",
  image: "Image",
  documents: "Documents",
  created_at: "Created",
  contact_info: {
    id: "ID",
    email: "Email",
    phone: "Phone",
    mobile: "Mobile",
    fax: "Fax",
    website: "Website",
    organization_name: "Organization Name",
    address_line_1: "Address Line 1",
    address_line_2: "Address Line 2",
    co: "c/o",
    postcode: "Postcode",
    countrycode: "Countrycode",
    city: "City",
    state: "State",
    country: "Country",
  },
  tags: "Tags",
  language: "Language",
  lists: "Subscribed lists",
  accounts: "Accounts",
  organization_names: "Assigned Organizations",
};

const userAndEnrollmentFilters = {
  emails: "Emails",
  qualifications: "Qualifications",
  categories: "Categories",
  event_base_categories: "Event Categories",
};
const customFieldContentTypeName = "Custom Field |||| Custom Fields";

const englishMessages = {
  ...defaultGermanMessages,
  resources: {
    applications: {
      name: "OAuth Application |||| OAuth Applications",
    },
    event_attendances: {
      name: "Attendance |||| Attendances",
      fields: {
        comment: "Comment",
        has_attended: "Attended",
      },
      actions: {
        add_absence: "Add Absence",
        edit_absence: "Edit Absence",
        add_comment: "Add Comment",
        edit_comment: "Edit Comment",
        mark_attended: "Mark as Attended",
        mark_unattended: "Mark as Unattended",
      },

      hints: {
        has_attended: "Attended",
        has_not_attended: "Not attended",
        has_attended_count: "Attended %{attendedCount} of %{attendedMax} sub-events",
        attendance_unknown: "Attendance unknown",
      },
    },
    attendance_absences: {
      name: "Absence |||| Absences",
      fields: {
        absence_start: "Start of Absence",
        absence_end: "End of Absence",
      },
      validation: {
        start_time_before: "Start of absence must be before %{maxTime}",
        start_time_after: "Start of absence must be after %{minTime}",
        end_time_after: "End of absence must be before %{maxTime}",
        start_time_before_end_time: "Start of absence must be before end of absence",
        end_time_after_start_time: "End of absence must be after start of absence",
      },
    },
    attendees: {
      name: "Participant |||| Participants",
      fields: { ...userFields, with: "Participant", attendee_number: "Customer Number" },
      actions: {
        update_contact_infos: "Update Contact Information",
        add_main_contact_info: "Communication",
        add_invoice_contact_info: "Invoice",
        add_invoice_dispatch_contact_info: "Invoice dispatch",
        enroll_to_moodle_courses: "Enroll in Moodle course(s)",
        add_new_interested: "Add new interested person",
        add_new: "Add new person",
        add_existing: "Existing persons",
        copy_main_contact_info: "Copy contact address",
        show_more_fields: "Show more fields",
        add_to_list: "Add to list",
        add_to_organization: "Add to organization",
      },
      hints: {
        booking_documents_at_booking: "Booking documents can be found at the respective booking.",
        debit_number_taken:
          "is already being used by another person or organization. Please make sure that this is what you want.",
        debit_number_outside_range: "Debit number %{debit_number} is outside the debit number range %{range}.",
        debit_number_range_open: "from %{start}",
      },
      is_archived: "Participant is archived",
      removed: "Person is deleted",
    },
    audiences: {
      name: "Target group |||| Target groups",
      fields: {
        name: "Name",
      },
    },
    auth_groups: {
      name: "Authorization group |||| Authorization groups",
    },
    customer: {
      name: "Customer profile |||| Customer profiles",
      fields: {
        name: "Name",
        value_added_tax_id: "Value-added tax ID",
        trade_register_number: "Trade register number",
        fiscal_number: "Tax number",
        iban: "IBAN",
      },
      hints: {
        no_customer_created_yet: "No customer profile has been created yet.",
      },
      sections: {
        general: "General",
        invoicing: "Invoicing",
      },
    },
    contacts: {
      name: "Contact |||| Contacts",
    },
    contact_persons: {
      name: "Contact person |||| Contact persons",
    },
    user_roles: {
      name: "Authorization group |||| Authorization groups",
      fields: {
        name: "Name",
        permission_groups: "Permissions",
      },
      auth_groups: {
        default: "Interface access",
        manage_events: "Manage events",
        manage_event_bases: "Manage offers",
        manage_orders: "Manage orders",
        manage_users: "Manage users",
        manage_attendees: "Manage participants",
        manage_interests: "Manage interested parties",
        manage_lecturers: "Manage lecturers",
        manage_todos_and_responsibilities: "Manage tasks & responsibilities",
        manage_bookings: "Manage bookings",
        manage_moodle: "Manage Moodle",
        manage_invoices: "Manage invoices",
        manage_access: "Manage EDM access",
        manage_templates: "Manage templates",
        manage_settings: "Manage settings",
        manage_base_data: "Manage master data",
        manage_organizations: "Manage organizations",
        view_accounting: "View EDM accounting",
        view_reporting: "View reporting",
        view_booking_list: "View booking list",
        view_invoice_list: "View invoice list",
        manage_accounting: "Financial accounting",
        manage_event_feedback: "Manage event feedback",
        view_feedback_report: "View feedback report",
        attendee: "Permissions for participants",
        lecturer: "Permissions for lecturers",
      },
      headlines: {
        permission_info: "Description of permissions",
      },
    },
    auth_users: {
      name: "Login",
      fields: {
        email: "Email",
      },
    },
    bookings: {
      name: "Booking |||| Bookings",
      fields: {
        event_date_attendances: "Attendance",
        has_attended: "Attended",
        price_positions: "Price positions",
        attendee: "Attendee",
        booking_number: "Booking number",
        status: "Status",
        created_at: "Booked on",
        format: "Participation format",
        first_name: "First name",
        last_name: "Last name",
        event: "Event",
        event_id_number: "Event number",
        amount: "Amount",
        price: "Price",
        invoices: "Invoice",
        invoiced_amount: "Invoiced",
        price_amount: "Amount",
        price_name: "Price name",
        attendee__last_name: "Last name",
        price__price_type__name: "Price type",
        order_item__order__order_number: "Order number",
        order: "Order",
      },
      calculated_fields: {
        paid: "paid",
        attended: "Attended",
      },
      actions: {
        cancel_order_item: "Cancel the order item |||| Cancel the order items",
        cancel_bookings: "Cancel booking |||| Cancel bookings",
        cancel_bookings_count: "Cancel booking |||| Cancel %{smart_count} bookings",
        invoices_menu: "Invoice",
        change_status: "Change status",
        create_invoices: "Create invoice |||| Create invoices",
        download_invoices: "Download invoice |||| Download invoices",
        send_invoices: "Send invoice |||| Send invoices",
        delete_invoices: "Delete invoice |||| Delete invoices",
        edit_invoices: "Edit invoice |||| Edit invoices",
        send_mail_to_all_bookings: "Email to all",
        send_mail_to_all_bookings_VALID: "%{bookingCount} registered participants",
        send_mail_to_all_bookings_WAITING: "%{bookingCount} waiting participants",
        send_mail_to_all_bookings_CANCELED: "%{bookingCount} canceled participants",
        send_mail_to_all_lecturers: "%{lecturerCount} lecturers",
        edit_attendance: "Edit attendance",
        mark_as_attended: "Mark as attended",
        mark_as_unattended: "Mark as unattended",
        add_as_interests: "Add as interested",
        alter_bookings: "Rebook",
        use_existing_price_type: "Use same price type",
        create_correction_invoice: "Create correction invoice for the canceled item",
        use_custom_fields_data: "Adopt extended booking fields",
        visit_website: "To the website",
        bill_to_other: "Assign the order to an organization / another payer",
        delete: "Delete booking |||| Delete bookings",
      },
      hints: {
        billing_unchanged:
          "The existing order item is assigned to the new event. Price, payments and invoices stay unchanged. Invoices already issued still name the previous event.",
        rebill:
          "The previous order item is canceled and replaced in the same order by a new item at the price selected below. Amounts already paid are not transferred to the new item. A correction invoice can be created for items already invoiced. An invoice for the new item can be created manually if needed.",
        rebill_prepaid: "Not possible for prepaid orders, please create a separate order.",
        order_item_stays_active:
          "The order item stays active, still counts as sold and remains due for invoicing. Only staff who may manage orders can cancel it. |||| The order items stay active, still count as sold and remain due for invoicing. Only staff who may manage orders can cancel them.",
        status_locked_by_canceled_item_rebooked: "The order item is canceled, so the booking stays rebooked.",
        status_locked_by_canceled_item: "The order item is canceled, so the booking stays canceled.",
        skipped_canceled_items:
          "%{smart_count} booking skipped because its order item is canceled |||| %{smart_count} bookings skipped because their order item is canceled",
        bookings_to_cancel: "%{smart_count} booking will be canceled. |||| %{smart_count} bookings will be canceled.",
        already_canceled:
          "%{smart_count} booking is already canceled. |||| %{smart_count} bookings are already canceled.",
        deleted: "Booking deleted |||| Bookings deleted",
        delete_explanation:
          "The booking is deleted for good and its order item is re-opened as unprocessed. |||| The bookings are deleted for good and their order items are re-opened as unprocessed.",
        bill_to_other:
          "Default: one separate order per person. Enable to group all attendees into a single order billed to an organization or another payer.",
        override_validation: "Skip the availability checks (capacity etc.) and allow overbooking.",
      },
      tooltips: {
        has_attended_event: "attended the event",
        has_attended_group_events: "attended %{attendedCount} of %{attendedMax} sub-events",
      },
      labels: {
        created_at: "booked on",
        rebooked_to: "rebooked to",
        rebooked_from: "rebooked from",
        booking_data: "Booking data",
        fallback_price: "Price if the price type is missing",
        billing_mode: "Order item",
        is_archived: "This booking is archived",
        no_bookings: "There are no bookings available.",
      },
      billing_modes: {
        UNCHANGED: "Keep order item",
        REBILL: "Cancel order item and create a new one",
      },
      status: {
        VALID: "Booked in",
        CANCELED: "Canceled",
        WAITING: "Waiting list",
        REBOOKED: "Rebooked",
      },
    },
    categories: {
      name: "Category |||| Categories",
      fields: {
        name: "Name",
        parent_category: "Parent category",
        parent_category_name: "Parent category name",
      },
      is_archived: "This category is archived",
    },
    checkouts: {
      name: "Checkout |||| Checkouts",
      fields: {
        checkout_id: "Checkout ID",
        payment_id: "Payment ID",
      },
    },
    consents: {
      name: "Consent |||| Consents",
      fields: {
        is_confirmed: "Confirmed",
        timestamp: "Created at",
        order_number: "Order number",
        additional_info: "Additional Information",
      },
      hints: {
        confirmation_thank_you: "Thank you for confirming!",
      },
    },
    consent_types: {
      name: "Consent type |||| Consent types",
      fields: {
        name: "Name",
        scope: "Scope",
        needs_confirmation: "Requires double opt-in",
        welcome_mail_template: "Email template after consent",
        confirmation_mail_template: "Consent Email Template",
        redirect_url: "Redirect URL",
        description: "Description",
        show_in_registration_form: "Show in registration form",
        registration_text: "Registration form text",
      },
    },
    contexts: {
      name: "Environment |||| Environments",
      fields: {
        name: "Name",
      },
    },
    content_types: {
      name: customFieldContentTypeName,
    },
    customer_invoices: {
      name: "Invoice |||| Invoice",
      fields: {
        id: "Invoice Number",
        to_datetime: "Bookings Up To",
        from_datetime: "Bookings From",
        minimum_price_per_month: "Minimum Price Per Month",
        created_at: "Created At",
        discount: "Discount",
        positions: "Booking Positions",
        commission_sum: "Commission Amount",
        commission_per_month: "Fixed Commission Per Month",
        invoice_sum: "Total Amount",
        attendee_name: "Attendee",
        booking_number: "Booking Number",
        order_number: "Order Number",
        event_name: "Event",
        booking_amount: "Booking Amount",
        commission: "Commission",
        positions_count: "Number of Booking Positions",
      },
      labels: {
        minimum_amount: "Minimum Amount",
      },
      filters: {
        negative_commission_only: "Show Only Negative Commission Amounts",
      },
    },
    custom_field_select_values: {
      name: "Select Values (Custom Fields)",
    },
    dashboard: {
      name: "Dashboard",
    },
    custom_fields_data: {
      name: customFieldContentTypeName,
      fields: {
        value: "Value",
      },
    },
    descriptions: {
      name: "Description |||| Descriptions",
      fields: {
        id: "ID",
        text: "Text",
        slug: "Slug",
      },
    },
    document_templates: {
      name: "Document Template |||| Document Templates",
      label: "Document Template",
      templateVersions: "Template Versions",
      version: "Version %{version}",
      input: {
        upload_version: "Upload New Version",
        store_permanently: "Save to %{scope}",
        show_custom_content: "Add Custom Content",
        hide_custom_content: "Hide Custom Content",
        custom_content: "Custom Content",
      },
      actions: {
        showMoreVersions: "Show All Versions",
        showLessVersions: "Less",
        generate: "Create Documents",
        save_and_close: "Save & Close",
        save_and_send: "Save & Send",
        download_all: "Download Bundled",
        example_menu: "Examples",
      },
      related_resource: {
        BOOKING_TEMPLATE: "Booking",
        EVENT_TEMPLATE: "Event",
        EVENT_BASE_TEMPLATE: "Offering",
        ATTENDEE_TEMPLATE: "Participant",
        LECTURER_TEMPLATE: "Lecturer",
        INVOICE_TEMPLATE: "Invoice",
        ORGANIZATION_TEMPLATE: "Organization",
        EVENT_LOCATION_TEMPLATE: "Event Location",
      },
      fields: {
        original_filename: "Filename",
        related_resource: "Context",
        created_at: "Created At",
        language: "Language",
        parent_template: "Parent Template",
      },
      notification: {
        only_ms_word_files_allowed: "Invalid file type. Allowed: .docx and .doc",
        successfully_generated:
          "%{smart_count} document was successfully generated |||| %{smart_count} documents were successfully generated",
        generation_finished: "Generation of document completed |||| Generation of documents completed",
        generation_in_progress: "Document is being generated |||| Documents are being generated",
        generation_other_pending:
          "%{smart_count} other document is generated first |||| %{smart_count} other documents are generated first",
        generation_error: "Error generating document |||| Error generating documents",
        persist_success: "Documents have been permanently saved",
        persist_error: "Error saving documents",
        no_templates_present: "No templates are available for this area.",
      },
      document_types: {
        participation_certificate: "Participation Certificate",
        name_plates: "Name Tags",
      },
    },
    edm_moodle_enrollments: {
      name: "Moodle Enrollment |||| Moodle Enrollments",
    },
    enrollments: {
      name: "Registration |||| Registrations",
      fields: {
        ...userFields,
        approval_url: "Approval link",
        approval_status: "Approval",
        approval_reason: "Reason",
      },
    },
    orders: {
      name: "Order |||| Orders",
      fields: {
        id: "ID",
        status: "Status",
        order_number: "Order number",
        buyer: "Buyer",
        organization: "Organization",
        user: "Buying person",
        payment_provider: "Payment method",
        is_paid: "Paid",
        is_fully_invoiced: "Fully invoiced",
        is_self_order: "Self-registration",
        total: "Total",
        buyer_note: "Buyer note",
        your_note: "Your note",
        note: "Your note",
        open_items: "Open items",
        item_count: "Items",
        events: "Events",
        created_at: "Created at",
      },
      filters: {
        has_processable_items: "Needs processing",
        person: "Buyer or attendee",
        event: "Event",
      },
      status: {
        pending: "Pending",
        confirmed: "Confirmed",
        canceled: "Canceled",
      },
      payment_status: {
        pending: "Pending",
        failure: "Failed",
        completed: "Completed",
      },
      checkout_failure_reason: {
        cancel_redirect: "The buyer canceled the checkout. The held seats were released.",
        expired_webhook: "The payment window expired. The held seats were released.",
      },
      payment_provider: {
        stripe: "Credit card (Stripe)",
        edm_invoice: "Invoice",
      },
      buyer_type: {
        user: "Person",
        organization: "Organization",
      },
      roles: {
        buying_person: "Buying person",
        organization: "Buying organization",
        attendee: "Attendees",
      },
      headlines: {
        custom_fields: "Custom fields",
        buyer: "Buyer",
        summary: "Summary",
        cancellation_email: "Cancellation email",
      },
      actions: {
        edit: "Edit order",
        create: "Create order",
        confirm: "Confirm",
        cancel: "Cancel",
        delete: "Delete order",
        create_invoice: "Create invoice",
        create_invoices: "Create invoices",
        quick_book_all: "Quick-book all (%{count})",
        quick_book: "Quick-book all",
        override_validation: "Skip checks (overbook)",
        create_correction_invoice: "Create correction invoice",
        create_reversal_invoice: "Create reversal invoice",
        create_correction_and_reversal_invoices: "Create correction and reversal invoices",
        refund: "Refund payment",
        email_buyer: "Email buyer",
        email_attendees: "Email attendees",
        email_buyers: "Email buyers",
        email_attendees_disabled: "None of the selected items has a booking - there is no attendee to write to.",
        resume_checkout: "Pay now",
      },
      hints: {
        invoice_canceled_order: "The order is canceled. Only custom positions can be billed, e.g. a cancellation fee.",
        ordered_at_by: "ordered on %{date} by",
        ordered_at: "from %{date}",
        confirmed: "Order confirmed",
        canceled: "Order canceled",
        deleted: "Order deleted",
        delete_explanation:
          "The order and all its items are deleted for good, as if they had never existed. Cancel instead when the order really happened.",
        delete_blocked:
          "This order can only be canceled, not deleted: an invoice, a payment attempt or a booking exists.",
        invoice_created: "Invoice created",
        invoice_ready: "The invoice and its document are ready.",
        invoice_document_failed:
          "The document could not be generated, so the invoice was discarded. Check the invoice template and create the invoice again.",
        document_ready: "Document ready",
        document_missing: "No document generated",
        skipped_item: "Item #%{id}: %{reason}",
        skipped_item_of_order: "%{order}: %{reason}",
        created: "Order created",
        buyer_without_billing_address:
          "This buyer has no billing address (street, postcode and city). No invoice can be generated for the order.",
        processed: "Items booked",
        search: "Search order number or organization",
        more_events: "Further events",
        confirm_explanation: "The order becomes binding. Bookings are created and invoices may be generated.",
        confirm_prepaid_explanation:
          "Prepaid order: confirming without a completed payment books the seats and sends the confirmations immediately, and the seats are no longer released automatically. No invoice is created here - issue one explicitly. A later payment is still invoiced automatically.",
        checkout_failed: "Payment failed - order canceled",
        create_invoice_explanation: "These lines will be billed.",
        bulk_create_invoice_explanation:
          "The selected bookings are grouped into one invoice per order (%{smart_count} order(s)). Canceled or already-invoiced items are skipped.",
        bulk_create_order_invoice_explanation:
          "One invoice is created per selected order (%{smart_count} order(s)), covering all confirmed, not-yet-invoiced items. Fully invoiced or unconfirmed orders are skipped.",
        bulk_order_invoice_nothing_selected: "Select at least one order.",
        bulk_create_item_invoice_explanation:
          "The selected items are grouped into one invoice per order (%{smart_count} order(s)). Canceled or already-invoiced items are skipped.",
        bulk_item_invoice_nothing_selected: "Select at least one item.",
        bulk_invoice_overrides:
          "Optional overrides applied to every created invoice. Leave empty and each invoice keeps its own resolved template, title and service period.",
        bulk_invoice_default_placeholder: "Per-order default",
        bulk_invoice_bookings_without_order:
          "%{smart_count} selected booking(s) are not linked to an order and cannot be invoiced.",
        bulk_invoice_nothing_selected: "None of the selected bookings can be invoiced.",
        bulk_invoice_missing_addresses:
          "One order has no usable billing address and will be skipped: %{orders} |||| %{smart_count} orders have no usable billing address and will be skipped: %{orders}",
        bulk_invoices_created: "%{smart_count} invoice created |||| %{smart_count} invoices created",
        bulk_invoices_skipped: "%{smart_count} item(s) were skipped (canceled, already invoiced, or not confirmed).",
        create_custom_invoice_explanation: "All items are already invoiced. Add lines below to write a custom invoice.",
        invoice_recipient_without_address:
          "%{name} has no usable billing address (street, postcode and city). Complete the invoice information below, otherwise no invoice can be created.",
        invoice_nothing_selected: "Add at least one line to invoice.",
        partially_processed: "%{count} of the items were booked. The rest is listed below.",
        process_order_explanation:
          "Creates a booking for all %{count} open, assigned items of this order. Items without a participant are skipped.",
        override_validation: "Skip the availability checks (capacity etc.) and allow overbooking.",
        override_validation_create: "Skip checks (capacity, registration window) on creation, to overbook.",
        override_validation_shortcut:
          "Shortcut: hold Shift while clicking the action to enable it only for that click.",
        change_buyer:
          "The buyer can only be changed while no invoice exists. Item participants are not changed automatically.",
        cancel_explanation: "The whole order is canceled and related bookings are canceled.",
        bulk_cancel_explanation:
          "%{smart_count} order(s) are canceled with all their items and bookings. Already canceled orders are skipped.",
        bulk_canceled: "Orders canceled",
        bulk_cancel_skipped_entry: "#%{id}: %{reason}",
        bulk_cancel_nothing_open: "Nothing left to cancel - the selection is already canceled.",
        bulk_cancel_no_credit_notes:
          "No correction or reversal invoice was created - the covering invoices are already corrected or reversed.",
        reversal_invoice_rest: "Invoices that are already partly corrected get a correction invoice for the rest.",
        cancel_event_started: "Event(s) already started:",
        cancel_event_finished: "Event(s) already finished:",
        cancel_event_elearning:
          "E-Learning without a fixed date. It may already have started or access may already have been granted:",
        no_invoices: "There are no invoices.",
        attendees: "One order item is created per selected person.",
      },
      labels: {
        no_orders: "You don't have any orders yet.",
        item_count: "%{smart_count} item |||| %{smart_count} items",
        seat_count: "%{smart_count} seat |||| %{smart_count} seats",
        more_events: "+ %{smart_count} more event |||| + %{smart_count} more events",
        self_buyer: "Yourself",
        document: "Document",
      },
    },
    order_items: {
      name: "Order item |||| Order items",
      processing_queue: "To process",
      labels: {
        no_items: "This order has no items.",
      },
      filters: {
        processing_queue: "View",
        queue_open: "Open items",
        queue_open_and_requests: "Open items and cancellation requests",
        queue_processed: "Processed items",
        cancellation_requested: "Cancellation requested",
      },
      fields: {
        id: "ID",
        approval_url: "Approval link",
        is_third_party: "Booked for someone else",
        price_type_name: "Price type",
        approval_emails: "Approver emails",
        state: "Status",
        user: "Attendee",
        event: "Event",
        price: "Price",
        offered_price: "Offer",
        adjust_price: "Adjust price",
        invoiced_amount: "Invoiced",
        attendees: "Attendees",
        format: "Format",
        approval_status: "Approval",
        approval_reason: "Reason",
        cancellation_reason: "Reason for cancellation (optional)",
        canceled_at: "Canceled at",
        created_at: "Created at",
        price_amount: "Price",
        notice: "Notice",
      },
      state: {
        open: "Open",
        booked: "Booked",
        denied: "Denied",
        canceled: "Canceled",
      },
      approval: {
        pending: "Approval pending",
        approved: "Approved",
        denied: "Denied",
      },
      actions: {
        cancel_emptied_orders: "Cancel the order |||| Cancel the orders (%{smart_count})",
        use_different_person: "Different attendee",
        use_buyer_as_attendee: "Buyer attends",
        adjust_price: "Adjust price",
        use_offer_price: "Use offer price",
        add: "Add position",
        add_and_book: "Book in directly",
        edit: "Edit position",
        edit_person_data: "Edit person data",
        edit_main_contact_info: "Edit contact data",
        edit_invoice_contact_info: "Edit billing address",
        edit_invoice_dispatch_contact_info: "Edit invoice dispatch address",
        use_from_source: "Copy from order",
        use_custom_fields_and_confirm: "Copy fields & use",
        request_approval: "Request approval",
        process: "Process",
        create_booking: "Create booking",
        create_waiting_list_booking: "Create waiting list booking",
        use_person: "Use this person",
        linked: "Linked",
        assign: "Assign person",
        reassign: "Reassign person",
        cancel: "Cancel",
        request_cancellation: "Request cancellation",
        request_cancellation_confirm:
          "Request cancellation of this item? The request is reviewed - nothing is cancelled automatically.",
        request_cancellation_confirm_button: "Request cancellation",
        request_cancellation_success: "Cancellation request has been sent.",
        request_cancellation_error: "Cancellation request failed. Please try again.",
        cancellation_requested: "Cancellation requested",
        delete: "Delete item",
        open_processing: "Process",
        quick_process: "Quick book",
        previous_item: "Previous item",
        next_item: "Next item",
      },
      headlines: {
        custom_fields: "Booking details",
        lists: "Lists",
        consents: "Consents",
        buyer: "Buyer",
        buyer_and_attendee: "Buyer & attendee",
        person_fields: "Personal details",
        matching_persons: "Existing participants",
        processing: "Process order item",
        attendee: "Attendee",
        purchase: "Booked offer",
        other_items: "Other items in this order",
        person: "People",
      },
      hints: {
        added: "Position added",
        previous_value: "previously: %{value}",
        add_blocked_canceled: "A canceled order can no longer be extended.",
        add_blocked_prepaid: "A prepaid order cannot be extended. Place a separate order for the additional position.",
        price_locked_prepaid:
          "This order is prepaid. Its price can no longer be changed - the buyer's checkout collects the total the order was created with. Place a separate order instead.",
        cancel_prepaid:
          "This order is prepaid. Canceling does not change what its checkout collects or has already collected - reconcile the payment manually afterwards.",
        items_in_orders:
          "The %{items} order items belong to %{smart_count} order. |||| The %{items} order items belong to %{smart_count} orders.",
        orders_keep_items:
          "%{smart_count} of them has other active items and is kept. |||| %{smart_count} of them have other active items and are kept.",
        remaining_orders_emptied:
          "The remaining order would otherwise have no active item left. |||| The remaining %{smart_count} would otherwise have no active item left.",
        all_orders_keep_items:
          "The order has other active items and is kept. |||| The orders have other active items and are kept.",
        cancel_emptied_orders:
          "Otherwise the order would have no active item left. |||| Otherwise these orders would have no active item left.",
        credit_note_mixed:
          "Canceled orders get a reversal invoice, invoices already partly corrected a correction invoice for the rest. For the other orders, a correction invoice for the canceled items is created.",
        add_to_confirmed_order:
          "This order is already confirmed. The new position is not invoiced automatically - invoicing stays a separate step.",
        book_requires_confirmed_order: "Booking is only possible once the order is confirmed.",
        edit_invoiced_item:
          "This item is already invoiced. A price change is not billed or credited automatically - issue a further invoice or a correction invoice for the difference.",
        thank_you_headline: "Thank you! Your data has been successfully submitted.",
        approval: "Approve",
        mismatch_in_person_data:
          "The stored data differs from this person's data. Copy the stored values or keep the existing ones?",
        request_approval_explanation:
          "Send the approval request to the approver addresses. Each approver gets a signed link to approve or deny.",
        approval_requested: "Approval request sent",
        approval_emails: "Separate multiple addresses with commas.",
        open_items_count: "%{count} open item |||| %{count} open items",
        processed_items_count: "%{count} processed item |||| %{count} processed items",
        no_processable_items: "No items to process.",
        no_processed_items: "No processed items.",
        unassigned: "Unassigned",
        processing_hints: "%{smart_count} note before booking |||| %{smart_count} notes before booking",
        event_fully_booked_short: "The event is already fully booked.",
        child_fully_booked_short: "The sub-event %{names} is already fully booked.",
        approval_denied_short: "The approval for this item was denied",
        similar_booking_short: "Possibly a duplicate booking - a similar booking already exists:",
        cancellation_requested_short: "A cancellation was requested for this item",
        bulk_cancel_explanation:
          "%{smart_count} item(s) are canceled with their bookings. The other items of their orders are not affected.",
        bulk_canceled: "Items canceled",
        processed: "Item booked",
        assigned: "Person assigned",
        canceled: "Item canceled",
        deleted: "Item deleted",
        delete_explanation:
          "The item is deleted for good, as if it had never existed. Cancel instead when it really happened.",
        delete_blocked:
          "This item cannot be deleted: it is booked or invoiced, or it is the order's last item (delete the order instead).",
        cancel_explanation: "This item is canceled and related bookings are canceled.",
        process_explanation: "Create a booking for %{name} in %{event}.",
        quick_process:
          "Quick booking for already-assigned items. For duplicate matching or assignment, open the processing page.",
        matching_persons: "Existing participants with a matching name or email. Link one to avoid duplicates.",
        no_matching_persons: "No matching persons found.",
        person_used: "Is Used",
        approval_for: "Registration approval",
      },
    },
    emails: {
      name: "Email |||| Emails",
      single_emails: "Individual emails",
      is_archived: "This email is archived",
      fields: {
        subject: "Subject",
        template: "Template",
        created_at: "Created at",
        status: "Status",
        to: "To",
        bounce_reason: "Bounce reason",
        scheduled_at: "Scheduled at",
      },
      status: {
        waiting_for_transfer: "Waiting for transfer",
        transfered: "Transferred",
        sent: "Sent",
        blocked: "Blocked",
        error: "Sending error",
      },
      actions: {
        resend: "Resend",
      },
      hints: {
        undeliverableEmails: "One email will not be delivered |||| %{smart_count} emails will not be delivered",
        duplicateRecipients: "One address receives several emails |||| %{smart_count} addresses receive several emails",
        noEmailAddress: "No email address available",
        noListConsentGiven: "No consent given for the list",
      },
    },
    email_jobs: {
      name: "Email dispatch |||| Email dispatches",
      is_archived: "This email dispatch is archived",
      fields: {
        created_at: "Created at",
        sender: "Sender address",
        body: "Body",
        emails: "To",
        attachments: "Attachments",
        recipients: "Recipients",
        template: "Template",
        created_by: "Created by",
        custom_to: "Email address",
      },
      actions: {
        group_by_jobs: "Group by dispatch",
      },
    },
    email_senders: {
      name: "Email senders",
      fields: {
        name: "Name",
        email: "Email",
        signature: "Signature",
        users: "Authorized staff",
        lecturers: "Authorized lecturers",
        external_id: "External ID",
        use_for_reply: "Use as reply address",
      },
    },
    event_lecturers: {
      name: "Lecturer |||| Lecturers",
    },
    events: {
      name: "Event |||| Events",
      name_singular: "Event",
      is_archived: "This event is archived",
      invalid_archive_filter: 'The archive filter is set to "All". Archiving not possible.',
      array_input_fields: {
        dates: "Dates and times",
        group_children: "Event |||| Events",
        group_parents: "Event group |||| Event groups",
        prices: "Price |||| Prices",
        lecturers: "Lecturer |||| Lecturers",
      },
      bulk_update_dates: {
        has_day: "Change day",
        has_time: "Change time",
        has_format: "Change format",
        has_location: "Change location",
      },
      fields: {
        id: "ID",
        attendees_max: "Attendees max.",
        attendees_min: "Attendees min.",
        capacity: "Capacity",
        child_event_base: "Offer",
        cost_center: "Cost center",
        cost_object: "Cost object",
        project_number: "Project number",
        created_at: "Created",
        event_base: "Offer",
        event_base_group_parent: "Offer group",
        group_parent: "Event group",
        group_child: "Event",
        external_url: "Public URL",
        first_day: "Appointment",
        last_day: "Last event day",
        first_day_end_time: "Appointment end",
        first_day_start_time: "Appointment start",
        id_number: "Number",
        inventory_account: "General ledger account",
        is_bookable: "Bookable",
        format: "Event format",
        is_solo_bookable: "Bookable individually",
        lecturers: "Teaching staff",
        location: "Event location",
        meta: {
          event_base_category_names: "Categories",
          event_base_name: "Offer title",
          event_base_type_name: "Offer type",
          all_valid_bookings_count: "Participation numbers",
        },
        online_invite_text: "Meeting information",
        prices: "Prices",
        registration_begin: "Registration period: Start",
        registration_deadline: "Registration period: End",
        remaining_dates: "Additional dates",
        responsibilities: "Responsibilities",
        responsible_persons: "Responsible persons",
        is_public: "Public",
        rooms: "Rooms",
        status: "Status",
        lecturers_may_edit_attendance: "Lecturers may edit attendance",
        display_in_portal: "Visible in portal",
        is_billable: "Is billable",
        bookings: "Bookings",
        event_location_name: "Event location name",
        event_lecturer_names: "Lecturer names",
        all_valid_bookings_count: "Number of valid bookings",
        all_waiting_bookings_count: "Number of pending bookings",
        is_child: "Event in a group",
        is_parent: "Event group",
        dates_count: "Number of dates",
        dates: "Dates",
        event_base__name: "Offer title",
        event_base__event_type__name: "Offer type",
        location__name: "Event location",
      },
      actions: {
        new_event: "Create new",
        existing_event: "Adopt data",
        create_event: "Create event",
        change_status: "Change status",
        bulk_update: "Update fields",
        change_format: "Change format",
        change_event_base: "Change offer",
        create_booking: "Add booking",
        create_bookings: "Add bookings",
        select_persons: "Select persons",
        select_event: "Select event",
        create_interest: "Add interested person",
        create_group: "Group",
        add_moodle_course: "Link Moodle course",
        remove_moodle_course: "Remove Moodle course link",
        show_event_base: "Show offer",
        add_to_event_group: "Add to group",
        add_child_event_to_group: "Add event",
        duplicate: "Duplicate",
        add_lecturer: "Add lecturer",
        add_new_lecturer: "Create and assign lecturer",
        connect_existing_lecturer: "Assign lecturer",
        edit_accounting_fields: "Edit accounting fields",
        edit_responsibilities: "Edit responsibilities for %{responsibilityType}",
        update_children_status: "Also update status of all sub-events",
        add_feedback_form: "Add feedback form",
        update_dates: "Edit dates",
      },
      validation: {
        number_not_unique: "The event number is already in use",
      },
      headlines: {
        cancel_order_items: "Cancel order items",
      },
      hints: {
        cancel_order_items_explanation:
          "The event is canceled. %{smart_count} item(s) of confirmed orders are still booked for it. Cancel them with their bookings? Items for other events in the same order stay untouched.",
      },
    },
    event_bases: {
      name: "Offer |||| Offers",
      name_singular: "Offer",
      is_archived: "This offer is archived",
      fields: {
        image_path: "Image path",
        name: "Name",
        slug: "URL segment",
        summary: "Summary",
        event_type: "Type",
        event_type_name: "Event type name",
        contact_persons: "Contact persons",
        group_parent: "Offer group",
        partners: "Cooperation partners",
        tags: "Keywords",
        contexts: "Environments",
        categories: "Categories",
        audiences: "Target audiences",
        descriptions: "Descriptions",
        image: "Image",
        documents: "Documents",
        created_at: "Created",
        updated_at: "Updated",
        external_url: "Public URL",
        event_count: "Number of events",
        event_type__name: "Type",
      },
      actions: {
        duplicate: "Duplicate",
        new_event_base: "New offer",
        existing_event_base: "Existing Offer",
        change_event_type: "Change Offer Type",
        create_event: "Add Event",
        create_event_base: "Create Offer",
        create_event_base_child: "Create Sub-Offer",
        create_event_group: "Create Event Group",
        show_event_base_group: "To Offer Group",
        add_description_field: "Add Field",
        show_old_descriptions: "Show Old Descriptions",
        hide_old_descriptions: "Hide Old Descriptions",
      },
    },
    event_base_descriptions: {
      name: "Offer Description |||| Offer Descriptions",
      fields: {
        description_type: "Description Type",
        text: "Text",
      },
    },
    event_base_description_fields: {
      name: "Description Field |||| Description Fields",
      fields: {
        label: "Label",
        slug: "Identifier",
        field_type: "Field Type",
        width: "Width",
        show_per_default: "Always Show",
        soft_required: "Required",
      },
    },
    event_dates: {
      name: "Date |||| Dates",
      fields: {
        has_attended: "Attended",
        id: "ID",
        event: "Event",
        day: "Day",
        different_location: "Different Location",
        start_time: "Start Time",
        end_time: "End Time",
        start_datetime: "Start",
        end_datetime: "End",
        location: "Different Location",
        format: "Different Format",
      },
      headlines: {
        date: "Date",
        date_details: "Date details",
      },
      formats: {},
    },
    event_feedback_forms: {
      name: "Event Feedback Form |||| Event Feedback Forms",
      fields: {
        event: "Event",
        valid_until: "Valid Until",
        feedback_form: "Feedback Form",
        url: "Form URL",
        name: "Form Name",
        reporting_visible_for_lecturers: "Evaluation available to lecturers",
      },
      actions: {
        download_qr_code: "Download QR Code",
        remove_from_event: "Remove from Event",
        edit: "Edit Feedback Form",
      },
      labels: {
        additional_text: "Explanation",
        add_text_response: "Add Text Response",
      },
    },
    event_locations: {
      name: "Event Location |||| Event Locations",
      fields: {
        image_path: "Image path",
        name: "Name",
        email: "Email",
        rooms: "Rooms",
        url: "URL",
        lat: "Latitude",
        lon: "Longitude",
        info: "Information",
        address: userFields.contact_info,
      },
    },
    event_moodle_courses: {
      name: "Moodle Course Link |||| Moodle Course Links",
      actions: {
        disconnect_moodle_course: "Disconnect Moodle Course Link",
      },
    },
    event_rooms: {
      name: "Event Room |||| Event Rooms",
      fields: {
        identifier: "Room Identifier",
        location_name: "Event Location",
      },
    },
    event_types: {
      name: "Offering Type |||| Offering Types",
      template_hint:
        "These templates apply to orders and bookings of this offering type. An order that spans several offering types uses the system default template. If a template is left empty, the default is used.",
      array_input_fields: {
        description_fields: "Description Field |||| Description Fields",
      },
      fields: {
        name: "Name",
        invoice_template: "Invoice Template",
        invoice_mail_template: "Invoice Email Template",
        booking_confirmation_template: "Booking Confirmation Email Template",
        order_manual_processing: "Order processing",
      },
      order_manual_processing_hint: "Orders that mix manual and automatic items are always processed manually.",
      order_manual_processing_choices: {
        inherit: "Use general setting (%{value})",
        manual: "Manual",
        auto: "Automatic",
      },
      headlines: {
        settings: "Display Settings",
        templates: "Templates",
      },
    },
    external_email_templates: {
      name: "Email Template |||| Email Templates",
      fields: {
        scope: "Scope",
        external_id: "External ID",
        subject: "Subject",
        sender: "Default Sender",
        is_default: "Default Template",
        bcc: "BCC Email Address",
        language: "Language",
        parent_template: "Parent Template",
        recipient_role: "Recipient",
        recipient_contact_info_type: "Address type",
      },
      helper_texts: {
        recipient_role: "If the order has no organization, the buying person receives the email.",
      },
      array_input_fields: {
        content_blocks: "Content Blocks",
        event_blocks: "Event Blocks",
      },
      headlines: {
        scope_info: "Description of scopes",
      },
    },
    feedback_forms: {
      name: "Feedback Form |||| Feedback Forms",
      fields: {
        name: "Name",
        introduction: "Introduction",
        closing_remark: "Closing Remark",
        questions: "Questions",
      },
      array_input_fields: {
        questions: "Questions",
      },
      actions: {
        add_question: "Add Question",
        add_as_new_question: "Add as New Question",
        send: "Send Feedback",
        group_questions: "Group by Questions",
        add_question_group: "Add Question Group",
        add_question_group_template: "Add Question Group template",
        new_question: "New Question",
        existing_question: "Existing Question",
        duplicate: "Duplicate",
      },
    },
    feedback_form_question_groups: {
      name: "Question Group |||| Question Groups",
      fields: {
        name: "Name",
        description: "Description",
      },
      template: "Question group template",
      hints: {
        load_from_template:
          "The selected question group, including the questions, will be added to the feedback form below. If the questions already exist in the feedback form, they will be ignored and not transferred.",
      },
    },
    question_select_values: {
      name: "Choice |||| Choices",
      fields: {
        value: "Value",
      },
    },
    files: {
      name: "Document |||| Documents",
      fields: {
        file_size: "File size",
        variant_urls: "Image variant URLs",
        id: "ID",
        data: "Data",
        related_id: "Related ID",
        related_resource: "Related Resource",
        mime_types: "MIME Types",
        created_by: "Created by",
        created_at: "Created At",
        url: "URL",
        description: "Description",
        name: "Name",
        name_sortable: "Name",
        original_filename: "Filename",
        tags: "Tags",
        visible_for_all: "Public",
        visible_for_attendees: "Released for participants in the portal",
        visible_for_lecturers: "Released for lecturers in the portal",
        visibility: "Releases",
      },
      actions: { open: "Open file" },
      hints: {
        file_not_previewable: "No preview is possible for this file format.",
      },
    },
    generated_documents: {
      name: "Automatically generated document |||| Automatically generated documents",
      hints: {
        persist_on_relation:
          "The document is stored on the current data record (%{relationName}) and is visible to employees. Additional approvals can be assigned: |||| The documents are stored on the %{relationName} and are visible to employees. Further approvals can be assigned:",
      },
    },
    generate_document_tasks: {
      name: "Document generation task |||| Document generation tasks",
    },
    integrated_applications: {
      name: "Linked application |||| Linked applications",
      fields: { active: "Active", name: "Name" },
      labels: {
        activate: "Activate",
        deactivate: "Deactivate",
        inactive: "Inactive",
        active: "Active",
        connect: "Connect",
        disconnect: "Disconnect",
        finish_oauth_connect: "Finish OAuth Connect",
      },
    },
    interests: {
      name: "Interested party |||| Interested parties",
      fields: {
        person: "Person",
        event_base_or_event: "Offer / Event",
        event_name: "Event",
        user_full_name: "Name",
        created_at: "Created",
        user__last_name: "Last name",
        note: "Note",
      },
      actions: {
        remove: "Remove favorite",
        edit: "Edit interest",
      },
    },
    invoices: {
      name: "Invoice |||| Invoices",
      headlines: {
        covered_items: "Covered items",
        related: "Related invoices",
        covered_line_items: "Already invoiced and free lines (%{count})",
        preview: "Preview",
        details: "Details",
      },
      fields: {
        title: "Title",
        first_name: "First Name",
        last_name: "Last Name",
        organization_name: "Organization Name",
        is_organization: "Is organization",
        debit_number: "Debtor Number",
        parent: "Original invoice",
        sum_without_tax: "Net total",
        kind: "Type",
        template: "Invoice template",
        override_contact_info: "Overwrite invoice information",
        price: "Price",
        name: "Title",
        download: "Download",
        invoice_number: "Invoice Number",
        service_period: "Service Period",
        generated_at: "Generated",
        created_at: "Invoice Date",
        due_date: "Due Date",
        sent_at: "Sent",
        recipient: "Invoice Recipient",
        payment: "Payment",
        accounting_transfer_success_at: "Transferred",
        accounting_transfer_error: "Transfer error",
        is_paid: "Paid",
        price_gross: "Gross",
        price_net: "Net",
        credited: "less correction and reversal invoices",
        effective: "Effective amount",
        booking__event__event_base__name: "Offer title",
        booking__attendee__last_name: "Last name",
        buyer_name: "Buyer",
        order__order_number: "Order number",
        paid_amount: "Paid amount",
        external_accounting_id: "Accounting ID",
        recipient_name: "Recipient name",
        reference: "Reference invoice",
        referenced_by: "Referenced by",
      },
      actions: {
        show_booking: "View Booking",
        show_order: "View Order",
        download: "Download Invoice",
        set_is_paid: "Mark as Paid",
        unset_is_paid: "Mark as Unpaid",
        bulk_reversal: "Cancel",
        reverse: "Reverse",
        correct: "Correct",
        add_line_item: "Add position",
        drop_line_item: "Remove",
        open_in_external_accounting: "Open in accounting",
        sync_with_external_accounting: "Synchronize with accounting",
        reset_accounting_transfer: "Reset transfer",
      },
      kinds: {
        standard: "Standard",
        correction: "Correction invoice",
        reversal: "Reversal invoice",
      },
      hints: {
        unresolved_accounting_lines_title: "Missing accounting fields",
        unresolved_accounting_lines_hint: "These events have no accounting fields yet:",
        accounting_transfer_error_hint: "An error occurred during transfer:",
        due_on: "Due on %{date}",
        pdf_not_generated: "The invoice document has not been generated yet.",
        reference: "An invoice of this order that the document refers to.",
        reverse_explanation: "This reverses the whole invoice with a reversal invoice. It cannot be undone.",
        correct_explanation: "These lines are created as a correction invoice.",
        reversal_created: "Reversal invoice created",
        document_generation_failed: "The document could not be generated. Check the invoice template.",
        correction_created: "Correction invoice created",
        reversal_partially_skipped:
          "Reversal invoice created; %{count} invoice(s) were skipped because they could not be reversed.",
        accounting_transfer_started: "Transfer to accounting started",
        reset_accounting_transfer_success: "Reset transfer successful",
        reset_accounting_transfer_error: "Error resetting transfer",
        reset_accounting_transfer_hint:
          "Are you sure you want to cancel the transfer? This will result in the loss of accounting data, and a new transfer can be started.",
        no_invoice_templates_present: "An invoice template (%{kind}) must be present before an invoice can be created.",
        line_item_already_invoiced: "This line is already invoiced. Add only what is being charged on top.",
        line_item_free: "Free line - nothing to invoice. Add only what is being charged on top.",
        line_item_not_billed: "Not billed",
        discarded_after_document_failure:
          "The invoice was discarded because no document could be generated. |||| The invoices were discarded because no documents could be generated.",
        credit_amount_negative: "The correction amount must be negative.",
        credit_amount_positive: "Correcting a discount line is a positive amount.",
        correction_nothing_selected: "At least one invoice line must keep its correction lines.",
        bulk_reversal_placeholder:
          "The placeholder %{invoiceNumber} is replaced with the corresponding original invoice number when the invoice is generated.",
      },
    },
    invoice_tax_amounts: {
      name: "Tax amount per rate |||| Tax amounts per rate",
      fields: {
        tax_rate: "Tax rate",
        amount: "Tax amount",
      },
    },
    invoice_templates: {
      name: "Invoice template |||| Invoice templates",
      fields: {
        name: "Name",
        zugferd_tax_exemption_reason_text: "Tax exemption reason",
        zugferd_payment_terms_description: "Payment terms description",
        zugferd_payment_means_code_type: "Payment means code type",
        is_default: "Default Template",
      },
      hints: {
        zugferd_fields: "ZUGFeRD Fields",
      },
    },
    lecturers: {
      name: "Lecturer |||| Lecturers",
      fields: userFields,
      is_archived: "This Lecturer is Archived",
      actions: {
        enroll_to_moodle_courses: "Enroll Lecturer in Moodle Course",
      },
    },
    notes: {
      name: "Note |||| Notes",
      fields: {
        high_priority: "Pinned",
        text: "Text",
      },
      actions: {
        pin: "Pin",
        unpin: "Unpin",
        delete: "Remove",
        create: "Create Note",
        update: "Update Note",
      },
    },
    contact_infos: {
      name: "Contact Information |||| Contact Informations",
      fields: userFields.contact_info,
    },
    moodle_courses: {
      name: "Moodle Course |||| Moodle Courses",
      fields: {
        id_number: "Course Number",
        name: "Course Name",
        category: "Category",
        short_name: "Short Course Name",
        start_date: "Course Start",
        end_date: "Course End",
      },
      actions: {
        connect: "Link with existing course",
        delete: "Also delete course in Moodle",
        create_new: "Create new course and link",
        enroll_remaining_attendees:
          "%{numberOfAttendees} more participant with Moodle account enroll |||| %{numberOfAttendees} more participants with Moodle account enroll",
        enroll_all_valid_attendees: "Enroll participants with Moodle account in course",
      },
      moodle_course_has_no_users_enrolled: "No participants have been enrolled in this course yet.",
      moodle_course_number_of_enrolled_bookings: "%{numberEnrollments} of %{numberBookings} participants enrolled",
      connected_lecturers: "Linked Lecturers",
    },
    moodle_enrollments: {
      name: "Moodle Enrollment |||| Moodle Enrollments",
      history_change: "for %{userName} in the course %{courseName}",
    },
    moodle_users: {
      name: "Moodle Account |||| Moodle Accounts",
      is_connected_with_moodle: "Is linked with a",
      actions: {
        delete: "Also delete account in Moodle",
      },
      moodle_number_of_enrollments_info:
        "There is %{smart_count} %{resource} enrolled in the selected Moodle courses |||| There are %{smart_count} %{resource} enrolled in the selected Moodle courses",
    },
    o_auth_apps: {
      name: "OAuth Application |||| OAuth Applications",
      fields: {
        is_superapplication: "Admin App",
        client_type: "Client Type",
        client_id: "Client ID",
        client_secret: "Client Secret",
        authorization_grant_type: "Authorization Grant Type",
        auth_groups: "Authorization Groups",
        redirect_uris: "Redirect URIs",
        post_logout_redirect_uris: "Post Logout Redirect URIs",
        skip_authorization: "Skip Authorization",
        pkce_required: "PKCE Required",
        algorithm: "Algorithm",
        application_permissions: "Permissions",
      },
      helper_texts: {
        client_secret_create: "Leave empty to auto-generate a secret.",
        client_secret_edit: "Hidden for security reasons. Leave empty to keep the current secret.",
      },
    },
    occupancy: {
      name: "Occupancy",
      fields: {
        unprocessed_order_items: "unprocessed order item |||| unprocessed order items",
        held_order_seats: "held seat (order) |||| held seats (orders)",
        attendees_max: "of max. %{max} participants",
        attendees_min_reached: "Minimum number %{min} reached",
        attendees_min: "until minimum number %{min}",
        waiting: "waiting",
        vacant_bookings: "available spot |||| available spots",
        vacant_waiting_hint: "%{count} on waiting list",
      },
    },
    organizations: {
      name: "Organization |||| Organizations",
      is_archived: "This organization is archived",
      self_created: "Created by",
      actions: {
        quick_create: "Create new organization",
      },
      fields: {
        id: "ID",
        invoice_contact_info: "Invoice",
        invoice_dispatch_contact_info: "Invoice Dispatch",
        name: "Name",
        tags: "Tags",
        debit_number: "Debtor number",
        value_added_tax_id: "VAT ID",
        trade_register_number: "Trade register number",
        self_created_by: "Self-created by",
        fiscal_number: "Tax number",
        created_at: "Created at",
      },
    },

    organization_memberships: {
      name: "Organization membership |||| Organization memberships",
    },

    organization_users: {
      name: "Person |||| Persons",
      labels: {
        no_members: "No persons are assigned to this organization yet.",
      },
      fields: {
        organization: "Organization",
        user: "Person",
        permissions: "Permissions",
        can_edit_organization: "May edit organization",
        can_enroll: "May place orders",
        can_manage_users: "May manage persons",
        create_login: "Set up portal access",
        created_at: "Created at",
      },
      hints: {
        create_login: "The person receives an email to set up their access.",
      },
      actions: {
        disconnect: "Remove connection",
        add_member: "Add person",
        select_existing_organization: "Existing organization",
        create_new_organization: "New organization",
      },
    },
    price_types: {
      name: "Price type |||| Price types",
      fields: {
        name: "Name",
        short_name: "Abbreviation",
      },
      is_archived: "This price type is archived",
      for_free: "For free",
    },
    price_positions: {
      name: "Position |||| Positions",
      default_first_position_name: "Participation",
      fields: {
        sales_tax: "Sales tax",
        attendee_name: "Participant",
        event_name: "Event",
        event_id_number: "Event number",
        amount: "Amount",
        name: "Name",
        quantity: "Quantity",
        inventory_account: "General ledger account",
        tax_rate: "VAT",
        incl_tax: "incl. %{amount} VAT",
      },
    },
    prices: {
      name: "Price |||| Prices",
      fields: {
        amount: "Amount",
        cached_amount: "Amount",
        positions: "Positions",
        price_type: "Price type",
        price_type_name: "Name of the price type",
        valid_from: "Valid from",
        valid_until: "Valid until",
      },
      labels: {
        amount: "Amount",
        invoiced_amount: "Invoiced amount",
        paid_amount: "Payment status",
        paid: "Paid",
        price_override: "Price adjusted manually",
      },
      tooltips: {
        amount:
          "The amount owed, with its price type. Zero reads as “free” - unless it is zero only because every position was canceled, in which case the amount itself is shown.",
        invoiced_amount:
          "As soon as part of the amount is invoiced, the invoiced sum is shown in front of it: grey while it stays below the amount, orange if it exceeds it. Once everything is invoiced, the amount turns green.",
        paid_amount:
          "A double green check means the whole amount is paid, a single check that everything invoiced so far is paid. A partial payment is shown as an amount instead. No marker means nothing has been paid yet.",
      },
    },
    partners: {
      name: "Cooperation partner",
      fields: {
        logo_path: "Logo path",
        id: "ID",
        name: "Name",
        url: "URL",
        logo: "Logo",
      },
    },
    qualifications: {
      name: "Qualification |||| Qualifications",
    },
    questions: {
      name: "Question |||| Questions",
      fields: {
        type: "Question Type",
      },
      types: {
        RATING: "Rating",
        SINGLE_CHOICE: "Single Choice",
        MULTIPLE_CHOICE: "Multiple Choice",
        FREE_TEXT: "Free Text",
      },
    },
    report: {
      name: "Evaluation",
    },
    response_forms: {
      name: "Feedback Evaluation",
      filters: {
        feedback_form: "Form",
        event: "Event",
        lecturers: "Lecturers",
        event_base: "Offering",
        responsible_person: "Responsible Person",
        question: "Question",
        date_to: "Created by",
        date_from: "Created to",
        question_type: "Question type",
      },
    },
    responses: {
      name: "Response |||| Responses",
    },
    responsibilities: {
      name: "Responsibility |||| Responsibilities",
    },
    responsibility_types: {
      name: "Responsibility type |||| Responsibility types",
      fields: {
        event_types: "Event Types",
      },
    },
    settings: {
      name: "General",
      fields: {
        value: "Value",
        key: "Setting",
      },
    },
    webhook_subscriptions: {
      name: "Webhook Subscription |||| Webhook Subscriptions",
    },
    subscriptions: {
      name: "Webhook |||| Webhooks",
      fields: {
        name: "Name",
        is_active: "Active",
        endpoint_url: "Endpoint URL",
        event_types: "Events",
        secret: "Secret",
      },
      helper_texts: {
        secret_edit: "Hidden for security reasons. Leave empty to keep the current secret.",
      },
    },
    tags: {
      name: "Tag |||| Tags",
      fields: {
        name: "Name",
      },
    },
    tax_rates: {
      name: "Sales tax rate |||| Sales tax rates",
      fields: { amount: "Percentage", untdid_category: "UNTDID 5305 Category", is_default: "Use as default" },
    },
    users: {
      name: "Person |||| Persons",
      fields: userFields,
      is_archived: "Person is archived",
      actions: {
        quick_create: "Create new person",
        add_invoice_contact_info: "Add differing billing address",
        connect_moodle_account: "Link Moodle account |||| Link Moodle accounts",
        disconnect_moodle_user: "Unlink Moodle account",
        unenroll_moodle_enrollment: "Unenroll from Moodle course",
        suspend_moodle_enrollment: "Set inactive in Moodle course",
        unsuspend_moodle_enrollment: "Set active in Moodle course",
        add_login: "Add login |||| Add logins",
        remove_login: "Remove login",
        change_email: "Change email",
        add_attendee_role: "Add attendee role |||| Add attendee roles",
        add_lecturer_role: "Add lecturer role |||| Add lecturer roles",
        remove_attendee_role: "Remove attendee role",
        remove_lecturer_role: "Remove lecturer role",
        create_interest: "Add interest",
      },
      login: { name: "Name", email: "Email", comment: "Comment" },
      gender: { male: "Male", female: "Female", non_binary: "Non-binary" },
    },
    user_moodle_users: { name: "Moodle account linking |||| Moodle account linkings" },
    staff_members: {
      name: "Staff member |||| Staff members",
      is_archived: "This staff member is archived",
      fields: {
        ...userFields,
        roles: "Permission groups",
        is_2fa_required: "Two-factor authentication required",
        color: "Color",
        email_senders: "Assigned email senders",
      },
    },
    two_factor: {
      name: "Two-factor authentication",
      actions: {
        reset_2fa: "Reset 2FA",
      },
      confirm: "Really reset two-factor authentication?",
      success: "Two-factor authentication successfully reset",
      error: "Two-factor authentication could not be reset.",
    },
    custom_field_content_types: {
      name: customFieldContentTypeName,
      content_types: {
        organization_users: "Organization persons",
      },
      fields: {
        resource: "Resource",
        slug: "Identifier",
        custom_fields: customFieldContentTypeName,
      },
    },
    custom_fields: {
      name: "Extended (master data) field |||| Extended (master data) fields",
      array_input_fields: {
        custom_fields: "Field |||| Fields",
      },
      actions: {
        add_field: "Add field",
        add_custom_field_section: "Add section",
      },
      notification: {
        slug_not_unique: "The label / identifier are not unique.",
      },
      headlines: {
        attendee_fields: "Attendee fields",
        booking_fields: "Booking fields",
      },
      fields: {
        label: "Label",
        slug: "Identifier",
        field_type: "Field type",
        data_type: "Data type",
        width: "Width",
        show_per_default: "Always show",
        soft_required: "Required",
        allowed_for_enrollment: "Allow for enrollments",
        allowed_for_order: "Allow for orders",
        allow_multiple_select: "Allow multiple selection",
        editable_by_user: "Editable in portal",
        editable_by_buyer: "Fillable when ordering",
        visible_for_attendees: "Released for participants in the portal",
        visible_for_lecturers: "Released for lecturers in the portal",
        relation_content_type: "Content type",
        field_types: {
          TEXT: "Text",
          TEXTAREA: "Text Area",
          RICHTEXT: "Rich Text Editor",
          NUMBER: "Number",
          DATE: "Date",
          BOOLEAN: "Yes / No",
          SELECT: "Select",
          RELATION: "Relation",
          RELATION_MANY: "Relation (multiple)",
        },
        field_info: {
          TEXT: "single-line text field",
          TEXTAREA: "multi-line text field",
          RICHTEXT: "Rich text",
          NUMBER: "number field",
          DATE: "date field",
          BOOLEAN: "Yes / No field",
          SELECT: "select field",
          RELATION: "Relation",
          RELATION_MANY: "Relation (multiple)",
        },
      },
    },
    todo_lists: {
      name: "Task list |||| Task lists",
      fields: {
        name: "Name",
      },
      array_input_fields: {
        todos: "Tasks",
      },
      actions: {
        add: "Create list",
        add_template_list: "Load template list",
        edit: "Edit list",
      },
    },
    todos: {
      name: "Task |||| Tasks",
      actions: {
        add: "Add task",
        edit: "Edit task",
        showDone: "Show recently completed tasks",
        hideDone: "Hide recently completed tasks",
      },
      fields: {
        assignee: "Assigned person",
        due_date: "Due date",
        text: "Text",
        is_done: "Completed",
        event__first_day: "Event",
      },
      filters: {
        due_date__lte: "Due by",
      },
      own_todos: "My tasks",
      no_todos: "You currently have no open tasks.",
      no_done_todos: "You have not completed any tasks yet.",
      hints: {
        reorder_error: "The new order could not be saved.",
      },
    },
    user_lists: {
      name: "List |||| Lists",
      fields: {
        name: "Name",
        is_public: "Public",
        brevo_id: "Brevo List ID",
        consent_type: "Consent type",
        users: "People",
        user_list: "List",
        description: "Description",
        brevo_list_name: "Brevo List Name",
        brevo_folder: "Brevo Folder",
        consent_given: "Consent already given",
        no_consent: "No Consent",
        consent_method: "Consents",
        trigger_confirmation: "Trigger Consent Process (Double-Opt-In)",
      },
      actions: {
        add_persons: "Add people",
        remove_from_list: "Remove from list",
        sync_to_brevo: "Sync to Brevo",
        import_from_brevo: "Import contacts from Brevo",
        connect_existing_brevo_list: "Connect existing Brevo list",
        connect_new_brevo_list: "Create new Brevo list",
        sync_list: "Sync list",
        save_and_sync: "Save and sync",
      },
      consent_dialog: {
        add_title: "Consent Required",
        add_message: "Do you want to accept this consent to be added to the list?",
        accept_consent: "Accept & Add to List",
        remove_title: "Remove Consent",
        remove_message: "Do you also want to remove your consent? You will be removed from the list regardless.",
        keep_consent: "Keep Consent",
        remove_consent: "Remove Consent",
      },
      hints: {
        brevo_sync_info:
          "Link a Brevo list - people will sync automatically. Use 'Sync List' to manually apply changes. Only new data is pushed to Brevo, nothing is deleted.",
        brevo_migrate_info:
          "Contacts from the linked Brevo list will be imported into EDM. If a user with the same login email exists in EDM, it's reused. Otherwise, a new 'contact' is created.",
        unsubscribe_success: "You have been successfully unsubscribed from the list.",
        unsubscribe_failure: "Unsubscribing from the list failed.",
      },
      sections: {
        subscribable: "Subscribable Lists",
      },
      filters: {
        consent_status: "Consented",
      },
      notifications: {
        successfully_added_users: "Person added to list |||| People added to list",
        successfully_updated_list: "List successfully updated",
      },
    },
    user_list_configurations: {
      actions: {
        rename: "Rename",
        manage_filters: "Show filters",
        save_as_new: "Save as new view",
        save_view: "Save view",
        save_changes: "Save changes",
      },
      hints: {
        error_loading_configuration: "Error loading custom views",
      },
    },
    user_list_data: {
      name: "Subscribed List |||| Subscribed Lists",
      fields: {
        combined_first_name: "First name",
        combined_last_name: "Last name",
        created_at: "Created at",
        combined_email: "Email",
        is_synced: "Synchronized",
        user__first_name: "First name",
        user__last_name: "Last name",
        user__contact_infos__email: "Email",
      },
      filters: {
        type: "Type",
        contacts: "Contacts",
        users: "Users",
      },
      actions: {
        remove_consent: "Also delete consent",
      },
      hints: {
        remove_confirm:
          "Are you sure you want to remove this person from the list? Please note: If a Brevo list is linked, the person will also be removed from the list in Brevo.",
      },
    },
  },
  page_sections: {
    actions: "Actions",
    orders: "Orders",
    relations: "Relations",
    sales: "Reporting",
    bookings: "Bookings",
    bookings_files: "Booking documents",
    child_event_bases: "Suboffers",
    contact_infos: "Contact information",
    core_data: "Master data",
    description: "Description",
    direct_bookings: "Direct bookings",
    event_groups: "Event groups",
    events: "Events",
    extended: "Advanced",
    files: "Documents",
    general: "Overview",
    groups: "Groups",
    high_priority_notes: "Important notes",
    history: "History",
    image: "Image",
    interested_users: "Interested",
    waiting_users: "Waiting list",
    potential_attendees: "Potential participants",
    interests: "Interests",
    login: "Login",
    moodle: "Moodle",
    notes: "Notes",
    password_reset: "Reset password",
    prices: "Prices",
    related_notes: "Linked notes",
    settings: "Settings",
    profile: "Profile",
    feedback_form: "Feedback forms",
    questions: "Questions",
    question_groups: "Question Groups",
    feedback: "Feedback",
    attendance: "Attendance",
    activity: "Activity",
    twofa: "Two-factor authentication",
    password_change: "Password management",
    visit_website: "Go to website",
    language_versions: "Language variants",
    attendees: "Attendee |||| Attendees",
    emails: "Outbox",
    persons: "Persons",
    organizations: "Organizations",
  },
  menu_sections: {
    export: "Export",
    bookings: "Bookings",
    communication: "Communication",
    participants: "Participants",
    roles_access: "Roles & access",
    moodle: "Moodle",
    manage: "Manage",
  },
  password_reset: {
    success: "The new password has been set",
    failure: "Password setting failed. Please request again.",
    submit: "Set new password",
    passwordsUnequal: "does not match password",
    passwordEmpty: "A password is missing",
    fields: {
      password: "Password",
      passwordConfirm: "Password confirmation",
    },
  },
  filters: {
    attendance_event_type: "Attendance type",
    attendance_category: "Category",
    attendance_event_base: "Offer",
    attendance_tags: "Tag",
    bookings: {
      attendee_state: "State (Communication)",
      attendee_state_invoice: "State (Invoice)",
      first_event_day_from: "Event from",
      first_event_day_to: "Event to",
      created_at_from: "Booked from",
      created_at_to: "Booked to",
      group_bookings: "Group bookings",
      booking_number: "Booking number",
      event_in: "Events",
      context: "Context",
      order_status: "Order status",
      order_organization: "Organization (order)",
    },
    categories: {
      has_parent_category: "Has parent category",
      parent_category_isnull: "Is parent category",
    },
    context: "Context",
    current: "Ongoing",
    created_at_from: "Created from",
    created_at_to: "Created to",
    custom_field_date_from: "%{label} from",
    custom_field_date_to: "%{label} to",
    events: {
      first_day_from: "Date from",
      first_day_to: "Date to",
      number_or_event_base_title: "Number / Offer title",
      fully_booked: "Fully booked",
      modules: "Modules",
      hide_modules: "Without modules",
      modules_only: "Modules only",
    },
    groups_only: "Groups only",
    have_attended: "Attended",
    history: {
      from: "From",
      to: "To",
      changed_by: "Changed by",
      resource: "Type",
    },
    invoices: {
      is_paid: "Is paid",
    },
    is_archived: "Archived",
    is_self_created: "Self-created",
    is_bookable: "Bookable",
    is_public: "Public",
    name: "Name",
    search: "Search",
    solo_event_bases_only: "Only individual offers",
    solo_events_only: "Only individual events",
    users: userAndEnrollmentFilters,
    upcoming: "Upcoming",
    user_list: "List",
    waitinglist_events: "Waiting List Events",
    valid_booking_event: "Booked Events",
    consent_type: "Consent Type",
    completion_status: "Sending Status",
    incomplete_email_jobs: "Incomplete Only",
    complete_email_jobs: "Complete Only",
    organizations: "Organizations",
  },
  hints: {
    event_date_details_inherited: "Greyed-out details are taken from the event's master data.",
    all_price_types_taken:
      "A price has been created for each price type. To add more prices, an additional price type must first be created.",
    user_without_email_present:
      "Selected record needs an email address. |||| All selected records need an email address.",
    accounting_invoice_already_present: "An invoice with this invoice number has already been transmitted.",
    child_of: "contained in",
    custom_field_models_present: "There are already %{resource} with %{field} set.",
    delete_invoice_with_children: "Deleting an invoice is only possible if no other invoices related to it exist.",
    disabled_add_dates: "The dates of an event group are generated from the dates of the associated events.",
    event_bulk_update:
      "Filled in fields are overwritten on all selected events. Empty fields stay unchanged, sub-events are not changed along with them.",
    unchanged: "Unchanged",
    event_status_label: "Status: %{status}",
    files_are_private:
      "This file is private and can only be accessed from here. |||| These files are private and can only be accessed from here.",
    files_are_public:
      "This file is publicly available and can be seen by anyone with the link. |||| These files are public and can be seen by anyone with the link.",
    group_bookings_selected: "Group bookings are selected",
    invoice_override_prices:
      "Usually, the current price of the selected booking is used to create the invoice |||| Usually, the current prices of the selected bookings are used to create the invoices",
    is_event_group: "Event group",
    is_event_base_group: "Offer group",
    is_group: "Group",
    is_group_booking: "Group booking",
    link_to_event_base: "To the offer page",
    external_sender_sync_hint:
      "Please only specify if the sender already exists in Brevo and should not be newly created",
    sender_delete_message: "Are you sure you want to delete this email sender?",
    login: {
      all_users_have_login: "%{resource} already has a login |||| All %{resource} already have a login",
      created: "Login created",
      email_absent: "No login email present",
      email_exists: 'If the login email already exists, participants can be merged using the "Merge" function.',
      not_all_users_have_login: "%{resource} does not yet have a login |||| Not all %{resource} have a login",
      present: "Login present",
      will_be_created: "Login will be created",
      email_empty: "Login can only be created with a valid email",
      consent_info:
        "By creating the logins, individuals automatically give their consent to use the participant/instructor portal. No double opt-in process takes place. Please ensure this is desired.",
      remove_confirm:
        "Removes the login from %{name}. The person record is kept; only their access to the participant/instructor portal is removed.",
    },
    role: {
      remove_attendee_confirm:
        "Removes the attendee role from %{name}. The person record is kept; only the attendee-specific data (audience role, debit number, custom fields) is deleted.",
      remove_lecturer_confirm:
        "Removes the lecturer role from %{name}. The person record is kept; only the lecturer-specific data (fee, qualifications, categories, custom fields) is deleted.",
    },
    moodle: {
      all_connected: "%{resource} is already connected |||| All %{resource} are already connected",
      connect_error: "Connection failed",
      connected: "is already connected",
      course_enrolled_users_count: "%{enrolledUsersCount} of %{bookingsCount} participants enrolled",
      course_without_enrollments: "No participants have been enrolled in this course yet.",
      not_all_users_have_account: "Not all %{resource} have a Moodle account",
      no_linked_courses: "No Moodle courses have been linked to this event yet",
      present: "linked with existing Moodle account (%{info})",
      will_be_created: "will be created in Moodle",
      has_moodle_account: "Moodle account linked",
    },
    payment: {
      self_managed: "Payment managed by the participant",
    },
    event_type_necessary_for_resource: "The offer type must be set before %{resource} can be created.",
    no_prices_present: "No prices are available for this event.",
    non_bookable_group_child: "Event is not individually bookable",
    update_main_contact_info: "Adopt communication address from registration for participant",
    update_invoice_contact_info: "Adopt billing address from registration for participant",
    update_invoice_dispatch_contact_info: "Adopt invoice dispatch address from registration for participant",
    all_users_have_login: "All %{resource} have a login",
    login_email_exists: 'If the login email already exists, participants can be merged using the "Merge" function.',
    login_email_absent: "No login email available",
    sub_record_fetch_error:
      "%{resource} for %{parentResource} could not be loaded. |||| %{resource} for %{parentResource} could not be loaded.",
    report: {
      data_info_headline: "Data Basis",
      data_info_content:
        'The underlying data is filtered by different event statuses depending on the selected period. For periods in the past, (bookings of) events with status "GO" and "Completed" are used. For periods in the future, however, (bookings of) events with status "Offered" and "GO" are used.',
      data_info_headline_bookings: "Bookings",
      data_info_content_bookings:
        "Whether a booking is considered for the selected period always depends on the event start date, the booking date itself does not matter.",
    },
    bulk_selection_limit_exceeded:
      "Warning: More than 1000 entries selected. This may cause errors in bulk processing.",
    similar_attendee_already_exists:
      "There are already bookings with similar data for the following persons for this event: %{names}. Please check to ensure this is not an unintentional double booking.",
    permission_denied_info:
      "You performed an action for which you have no permissions. If you need additional permissions, please contact your administrator.",
    current_user_roles: "Your current permission groups",
    custom_field_select_already_used:
      "The value for this field is already stored in %{count} %{resource}. Do you still want to edit the selection? Old values remain unchanged and will not be updated.",
    feedback_module_of: "Feedback module of the",
    feedback_not_found_headline: "No suitable feedback form could be found for this link",
    feedback_not_found_info: "Please check if the link is correct. The validity of the link may have expired.",
    copied_to_clipboard: "Copied to clipboard.",
    custom_field_slug_already_exists_elswhere:
      "This slug already exists for %{resource}. Duplication may result in data with this slug being adopted for both booking and the participant during registration. If this is not intended, a different slug should be used.",
    enrollment_already_approved: "This registration has already been processed.",
    enrollment_not_found_headline: "Unfortunately, no suitable registration could be found for this link",
    error_info:
      "Unfortunately, an error occurred while processing your request. This usually indicates a technical problem within EDM. If the error persists, please contact our support: ",
    not_found_info:
      "Unfortunately, the page you called up could not be found. Please check the URL or contact our support if in doubt: ",
    only_canceled_bookings_can_be_archived: "Only canceled bookings can be archived.",
    add_lecturers_to_event_children: "Assign lecturer additionally to these sub-courses:",
    change_event_base_with_child_or_parent:
      "This event is part of an event group. Please note that only the offer for the current event will be changed. Parent or child events must be edited separately.",
    sender_delete_external: "Also delete from external email service (Brevo)",
  },
  validations: {
    url: "URL is not valid (must start with http:// or https://)",
    slug_chars: "only letters, numbers and - valid",
    registration_begin_after_deadline: "Registration begin date must be before or equal to registration deadline",
    registration_deadline_before_begin: "Registration deadline must be after or equal to registration begin date",
    first_day_after_last_day: "First day must be before or equal to last day",
    last_day_before_first_day: "Last day must be after or equal to first day",
    attendees_min_greater_than_max: "Minimum attendees must be less than or equal to maximum attendees",
    attendees_max_less_than_min: "Maximum attendees must be greater than or equal to minimum attendees",
    start_time_after_end_time: "Start time must be before or equal to end time",
    end_time_before_start_time: "End time must be after or equal to start time",
  },
  confirmations: {
    moodle: {
      disonnect_user: "Disconnect %{name} (%{email}) from Moodle?",
      connect_user_create: "Create an account for %{name} (%{email}) in Moodle?",
      connect_user_with_existing:
        "An account with email address %{email} already exists in Moodle. Do you still want to link the account?",
      unenroll_moodle_enrollments:
        "Should %{moodleUser} be unenrolled from the course %{courseName}? |||| Should the selected participants be unenrolled from the course %{courseName}?",
      suspend_moodle_enrollments:
        "Should %{moodleUser} be set to inactive in the course %{courseName}?? |||| Should the selected persons be set to inactive in the course %{courseName}?",
      unsuspend_moodle_enrollments:
        "Should %{moodleUser} be set to active in the course %{courseName}?? |||| Should the selected persons be set to active in the course %{courseName}?",
      disonnect_course: "Disconnect %{name} from Moodle?",
    },
    event_title: "Recommended fields for the event not filled",
    event_text:
      "Not all recommended fields have been filled for this event. This may lead to incomplete presentation of the event on the website. The following recommended fields were not filled:",
    event_fields: "Event fields:",
    event_base_change_bookings_present: "Bookings are present",
    event_base_change_explanation:
      "Changing the offer may alter the content description for this event. Do you still want to change the offer for this event?",
    event_base_fields: "Offer fields:",
    event_save_anyway: "Publish anyway",
    event_save_draft: "Save as draft",
    event_base_save_anyway: "Save anyway",
    event_base_failed_soft_validation_title: "Recommended fields for the offer not filled",
    event_base_failed_soft_validation_text:
      "Not all recommended fields have been filled for this offer. This may lead to incomplete presentation of the event on the website. The following recommended fields were not filled:",
    delete_invoice:
      'Please note that clicking "Confirm" will irreversibly delete the selected invoice. This may cause accounting and/or tax issues if the invoice is already in circulation.',
    delete_custom_field:
      "Are you sure you want to delete this field? This will also delete any data that may be stored in it.",
    delete_custom_field_section:
      "Are you sure you want to delete this section? All fields contained in it, as well as any data that may be stored in them, will also be deleted.",
    delete_following_custom_fields: "The following fields (including stored data) will be deleted:",
    delete_custom_field_with_data:
      "A dataset exists where %{label} is set. |||| %{smart_count} datasets exist where %{label} is set.",
    edit_invoice:
      "Please note that you are about to edit an existing invoice. This may cause accounting and/or tax issues if the invoice is already in circulation.",
    failed_soft_validation_title: "Recommended fields not filled",
    failed_soft_validation_text:
      "Not all recommended fields for this record have been filled. The following recommended fields are missing:",
    check_values_title: "Check values",
    check_values_text: "Please check before saving:",
    slug_changed_title: "Identifier changed",
    slug_changed_text:
      "Existing descriptions are linked to the description field by its identifier. Should the descriptions already entered for this offer type be moved to the new identifier? Otherwise they lose their link.",
    slug_changed_move_descriptions: "Move descriptions",
    slug_changed_keep_descriptions: "Only save field",

    non_template_descriptions_present_title: "Descriptions no longer valid",
    non_template_descriptions_present_text:
      "%{smartCountDescriptions} no longer compatible with the description fields of the new offer type.",
    remove_from_event_group: "Do you really want to remove this event from the event group?",
    remove_from_event_base_group: "Do you really want to remove this offer from the offer group?",
    remove_lecturer_from_event: "Do you really want to remove this lecturer from the event?",
    event_base_name_already_present: "Offer title already exists",
    event_base_name_already_present_explanation:
      "The offer title already exists outside a group. Therefore, this offer cannot be removed from the group. Please rename one of the offers first.",
    group_mark_as_attended:
      'Since these are bookings of an event group, this action affects all sub-events. The selected participants will be marked as "attended" in all sub-events.',
    group_mark_as_unattended:
      'Since these are bookings of an event group, this action affects all sub-events. The selected participants will be marked as "did not attend" in all sub-events.',
    add_as_interests: 'Do you want to additionally add the selected bookings as "Interested"?',
    alter_bookings:
      'The selected persons are booked into the event selected below. In the current event, their status is set to "Rebooked".',
    custom_field_select_edit_anyway: "Edit selection anyway",
    unsaved_changes_dialog: "You have made changes to the form. Do you really want to close the dialog?",
    close_dialog: "Do you really want to close the dialog?",
    delete_feedback_form:
      "Do you really want to delete this feedback form? If there are already responses to this form, they will also be deleted.",
    delete_question_group:
      "Do you really want to delete this question group? All questions within the question group will be removed from the feedback form. If there are already responses to the included questions, they will also be deleted.",
    delete_question:
      "Do you really want to delete this question? If there are already responses to this question, they will also be deleted.",
    delete_user:
      "When this action is executed, all user data will be permanently deleted. Bookings, associated invoices and sent emails are excluded. Buyers of open orders cannot be deleted until the order is canceled or completed.",
    delete_organization:
      "The organization, its contact data, members and custom field data will be permanently deleted. Organizations with orders cannot be deleted, archive them instead.",
    bulk_attendances_different_values: "Some bookings already have different values for attendance recorded:",
    values_will_be_overwritten: "These values will be overwritten. Do you want to proceed anyway?",
  },
  settings: {
    relative_commission_per_booking: {
      name: "Relative commission per booking",
      description: "This factor is used to calculate the relative commission per booking.",
    },
    automated_data_deletion_active: {
      name: "Automated deletion of user and invoice records",
      description: "Enable automated deletion of user and invoice records system-wide.",
    },
    automated_data_deletion_user_threshold_days: {
      name: "User deletion threshold in days",
      description: "After how many days users are automatically deleted.",
    },
    automated_data_deletion_invoice_threshold_days: {
      name: "Invoice deletion threshold in days",
      description: "After how many days invoices are automatically deleted.",
    },
    relative_commission_eur_cap_per_booking: {
      name: "Maximum relative commission per booking (€)",
      description: "The maximum amount in euros that can be calculated as a relative commission per booking.",
    },
    fix_commission_per_booking: {
      name: "Fixed commission per booking (€)",
      description: "This amount is calculated per booking in addition to the relative commission.",
    },
    fix_commission_per_month: {
      name: "Fixed commission per month (€)",
      description: "This amount is calculated as a fixed monthly fee.",
    },
    default_event_location: {
      name: "Default event location",
      description: "This location is preselected when creating events.",
    },
    default_event_type: {
      name: "Default offer type",
      description: "This offer type is preselected when creating offers.",
    },
    default_price_type: {
      name: "Default price type",
      description: "This price type is preselected when creating bookings.",
    },
    logo_path: {
      name: "Logo URL",
      description: "The URL of the desired logo in the login area.",
    },
    login_text: {
      name: "Login Text",
      description: "Info text displayed during login.",
    },
    imprint_url: {
      name: "Imprint URL",
      description: "The URL to the imprint in the login area.",
    },
    data_privacy_url: {
      name: "Data Privacy URL",
      description: "The URL to the data privacy in the login area.",
    },
    stripe_api_key: {
      name: "API Key",
      description: "Der API Key, den Sie von stripe erhalten.",
    },
    stripe_cancel_redirect: {
      name: "Weiterleitung bei Fehler",
      description: "Die URL, zu der nach einem Abbruch des Checkouts, weitergeleitet wird.",
    },
    stripe_success_redirect: {
      name: "Weiterleitung bei Erfolg",
      description: "Die URL, zu der nach einem erfolgreichen Checkout weitergeleitet wird.",
    },
    stripe_invoice_name: {
      name: "Rechnungsname",
      description: "Der Bezeichner, der für die Rechungsdokumente verwendet wird.",
    },
    stripe_webhook_secret: {
      name: "Webhook secret",
      description: "Das Webhook secret von Stripe.",
    },
    scopevisio_customer_id: {
      name: "Scopevisio Customer ID",
      description: "The Scopevisio customer number",
    },
    scopevisio_refresh_token: {
      name: "Scopevisio Refresh Token",
      description: "This token is used to access the Scopevisio API",
    },
    scopevisio_webhook_secret: {
      name: "Scopevisio Webhook Secret",
      description: "Expected in the X-Scopevisio-Webhook-Secret header",
    },
    moodle_api_token: {
      name: "Moodle API Token",
      description: "This token is used to access the Moodle API",
    },
    moodle_attendee_role_id: {
      name: "Attendee Role",
      description: "This role is assigned to attendees when booking",
    },
    moodle_host: {
      name: "Moodle Host",
      description: "The hostname of the server where the Moodle instance runs",
    },
    moodle_lecturer_role_id: {
      name: "Lecturer Role",
      description: "This role is assigned to lecturers when booking",
    },
    moodle_service: {
      name: "Moodle Webservice",
      description: "The name of the web service stored on the Moodle server",
    },
    moodle_url: {
      name: "Moodle URL",
      description: "URL of the Moodle instance (used for linking)",
    },
    custom_theme: {
      name: "Custom Theme for EDM Portal",
      description: "Material UI theme for the EDM portal (attendees & lecturers).",
    },
    days_lecturers_may_change_attendance_after_event: {
      name: "End of editing for participation by instructors",
      description: "How many days after the event end can instructors still edit participation",
    },
    is_portal_active: {
      name: "EDM portal for participants and instructors",
      description: "Activate EDM portal for participants and instructors",
    },
    website_url: {
      name: "Website URL",
      description: "The URL to your own website. This is linked in the portal, for example.",
    },
    lecturer_booking_export_active: {
      name: "Lecturers may export bookings",
      description: "Should an export function for bookings be displayed in the portal for lecturers?",
    },
    lecturer_emailing_active: {
      name: "Lecturers may send e-mails",
      description: "Should an e-mail function be displayed in the portal for lecturers?",
    },
    favicon_url: {
      name: "Favicon-URL",
      description: "The URL to the desired favicon for public pages.",
    },
    read_emails_independent_of_sender: {
      name: "Employees may view all emails",
      description: "Employees may view emails independently of the sender.",
    },
    storefront_config: {
      name: "Storefront configuration",
      description: "Settings for the storefront",
    },
    public_portal_registration: {
      name: "Public registration form (portal)",
      description: "Should the registration form for the portal be publicly accessible?",
    },
    read_only: "This setting cannot be changed here.",

    default_bcc: {
      name: "Default BCC",
      description: "Email address added as BCC on all outgoing emails.",
    },
    frontend_event_base_path: {
      name: "Offer Path",
      description: "Path template for offer pages. Placeholder: {slug}",
    },
    frontend_event_path_segment: {
      name: "Event Path Segment",
      description: "Path segment for individual events. Placeholder: {id}",
    },
    groups: {
      general: "General Configuration",
      portal: "Portal",
      defaults: "Default Values",
      storefront: "Website",
      orders: "Orders & Invoices",
    },
    order_validation_capacity: {
      name: "Check capacity",
      description: "Checks whether an order exceeds an event's maximum number of attendees.",
    },
    order_validation_registration_window: {
      name: "Check registration window",
      description: "Checks whether an order comes in within an event's registration period.",
    },
    order_validation_event_started: {
      name: "Check event start",
      description: "Checks whether an event has already started when it is ordered.",
    },
    order_validation_levels: {
      off: "Off",
      internal: "Always accept customer orders",
      everywhere: "Always check",
      help: "Always accept customer orders: orders via website, registration forms and API are accepted without the check. The error only appears when staff process or confirm such an order. If orders are booked automatically, the attendee is booked anyway.\nAlways check: customer orders are rejected as well.",
    },
    order_validation_billing_address: {
      name: "Enforce billing-address check",
      description:
        "Reject orders that will be invoiced when the buyer has no usable billing address. For organization orders, the organization's address counts. Only applies to automatically processed orders; with manual processing the error only appears when the invoice is created.",
    },
    order_checkout_window_minutes: {
      name: "Checkout window (minutes)",
      description: "How long a pending order holds event seats during checkout.",
    },
    order_manual_processing: {
      name: "Manual order processing",
      description:
        "When on, order items stay open until staff process them into a booking. When off, items are booked automatically once the order is confirmed. Offering types can override this.",
    },
    order_unverified_user_retention_days: {
      name: "Unverified person retention (days)",
      description:
        "After how many days self-submitted, unverified person records are deleted. People with a booking, an open order or an invoiced item are always kept. 0 = no deletion.",
    },
    invoice_payment_term_days: {
      name: "Payment term (days)",
      description:
        "How many days after the invoice date an invoice is due. The due date is stored when the invoice is created and transmitted to accounting. 0 = no due date.",
    },
    debit_number_start_index: {
      name: "Debit number range start",
      description: "First number EDM issues.",
    },
    debit_number_end_index: {
      name: "Debit number range end",
      description: "Last number of the range. Empty = unlimited. Once the range is full, creating invoices fails.",
    },
    organization_debit_number_start_index: {
      name: "Organization debit number range start",
      description: "Optional own range for organizations. Empty = organizations use the range above.",
    },
    organization_debit_number_end_index: {
      name: "Organization debit number range end",
      description: "Last number of the organization range. Empty = unlimited.",
    },
    debit_number_ranges: {
      help: "Ranges EDM issues new debit numbers from (assigned by accounting). Changes only apply to newly issued numbers; issued numbers stay.",
      errors: {
        end_without_start: "An end requires a start.",
        end_before_start: "The end must be greater than or equal to the start.",
        overlap: "The ranges for persons and organizations overlap. A missing end counts as unlimited.",
      },
    },
    invoice_auto_accounting_transfer: {
      name: "Transfer invoices to accounting automatically",
      description:
        "When active, newly created invoices are transferred to accounting automatically. Automatically created invoices - with manual order processing off, and after a successful online payment - are transferred regardless of this setting.",
    },
    create_organization_with_account: {
      name: "Offer organization creation on sign-up",
      description: "Let users create an organization when registering an account.",
    },
    cancellation_period: {
      name: "Cancellation Period (days)",
      description:
        "Number of days after booking creation during which cancellation is possible. 0 = no cancellation possible.",
    },
    cancellation_contact_email: {
      name: "Cancellation Contact Email",
      description: "Email address to receive notifications when a booking is cancelled in the portal.",
    },
    headlines: {
      emailing: "Emails",
      links: "Links",
      lecturers: "Lecturers",
      cancellation: "Cancellation",
      data_deletion: "Data deletion",
      order_processing: "Order processing",
      availability_checks: "Availability checks",
      invoicing: "Invoices",
      debit_number_ranges: "Debit number ranges",
    },
  },
  sidebar: {
    admin_section: "Administration",
    accounting_section: "Sales",
    users_section: "People",
    imprint: "Imprint",
    data_privacy: "Data Privacy",
    info: "Info",
    administration: {
      main_data: "Master data",
      user_management: "Access",
      template_management: "Templates",
      settings: "Settings",
    },
  },
  empty_state: "No %{entity} available.",
  no_category: "No category",
  no_date: "No date",
  no_event_base: "No offering",
  no_value: "No value",
  no_state: "No state",
  oclock: "%{time} o'clock",
  all: "All",
  already_taken: "is already taken",
  born: "born %{date}",
  no_name: "No name (#%{id})",
  "Bad Request": "Request failed",
  Forbidden: "No permission for this action",
  "Not Found": "Record not found",
  Unauthorized: "Not allowed",
  "Internal Server Error": "Internal server error",
  "NetworkError when attempting to fetch resource.": "Request failed due to network error.",
  invalid_grant: "Credentials are invalid",
  login_error: "Login currently not possible",
  login_error_message:
    "Unfortunately, an error occurred while communicating with the server. Please try again or contact the administrators.",
  try_again: "Try again",
  enlarge: "Enlarge",
  shrink: "Shrink",
  notification: {
    login_created: "Login added |||| Logins added",
    connect_success: "%{entity} successfully linked",
    disconnect_success: "%{entity} successfully disconnected",
    disconnect_error: "Failed to disconnect %{entity}",
    moodle: {
      connect_error: "Failed to link %{entity}",
      enrollment_success: "%{resource} successfully enrolled",
      enrollment_error: "Failed to enroll %{resource}",
      unenroll_success: "%{resource} successfully unenrolled",
      unenroll_error: "Failed to unenroll %{resource}",
      suspend_success: "%{resource} successfully set to inactive",
      suspend_error: "Failed to set %{resource} to inactive",
      unsuspend_success: "%{resource} successfully set to active",
      unsuspend_error: "Failed to set %{resource} to active",
      create_error: "%{entity} could not be created",
    },
    remove_from_group_error: "Failed to remove from group",
    remove_from_group_success: "Removed from group",
    upload_error: "An error occurred during uploading.",
    upload_error_reason: "Upload failed: %{reason}",
    unsupported_file_type: "This file type is not supported. Allowed types: %{types}.",
    upload_success: "Upload successful",
    check_for_password_reset: "Email to reset password sent",
    password_reset_error: "Email address invalid or not found",
    delete_error: "Error deleting the record",
    delete_price_enrollment_error:
      "The price cannot be deleted because %{entityCount} unfinished %{enrollment} with this price exist.",
    duplicate_todos_error: "Error duplicating tasks. However, the event was created.",
  },
  archiving: {
    archive: "Archive",
    archive_confirm: "Really archive %{resource}? |||| Archive %{entityCount} %{resource}?",
    archive_success: "%{resource} successfully archived",
    archive_error: "Archiving failed",
    events_affected: "Affected events: ",
    unarchive: "Restore",
    unarchive_confirm: "Really restore %{resource}? |||| Restore %{entityCount} %{resource}?",
    unarchive_success: "%{resource} successfully restored",
    unarchive_error: "Restoration failed",
    valid_bookings_affected: "Affected valid bookings: ",
  },
  editor: {
    hints: {
      bold: "Bold",
      italic: "Italic",
      heading1: "Heading 1",
      heading2: "Heading 2",
      heading3: "Heading 3",
      undo: "Undo",
      redo: "Redo",
      paragraph: "Paragraph",
      list: "List",
      numberedList: "Numbered List",
      todoList: "To-Do List",
      link: "Link",
    },
  },
  emailing: {
    attachments: "Attachments",
    attendance_confirmation: "Send attendance confirmation",
    body: "Content",
    booking_confirmation: "Send booking confirmation",
    order_confirmation: "Send order confirmation",
    content_blocks: "Content Blocks",
    event_blocks: "Event Blocks",
    email_interested_users: "Contact interested person |||| Contact interested people",
    feedback: "Send feedback form",
    invoice_kind: "Invoice Type",
    invoice_not_found: "An invoice could not be assigned to the recipient and therefore cannot be sent.",
    no_body: "The content of the email is currently not available.",
    open_errors: "Unresolved errors",
    related_records: "Related records",
    archive_job_hint: "All emails of this dispatch are archived as well.",
    unarchive_job_hint: "All emails of this dispatch are restored as well, including the individually archived ones.",
    no_template: "No template selected",
    no_receivers: "No valid recipients available",
    no_templates_for_scope: "No email templates are stored for this area yet.",
    no_assigned_senders: "You have not yet assigned any email senders.",
    receivers: "Recipients",
    send: "Send",
    send_email: "Send Email",
    recipients_label: "Recipients:",
    sendtest: "Send Test",
    signature: "Signature",
    subject: "Subject",
    sender: "Sender",
    error: "Error sending the email |||| Error sending the emails",
    sent_to_sib_at: "Transferred to Brevo at",
    success: "Email(s) sent successfully",
    template: "Template",
    test_error: "Error sending test email",
    test_success: "Test email sent successfully",
    testaddress: "Test Email Address",
    with_generated_document: "The generated document will be automatically sent as an attachment.",
    invoice_document_missing:
      "No document exists yet for %{smart_count} invoice; it will be sent without an attachment. |||| No document exists yet for %{smart_count} invoices; they will be sent without an attachment.",
    upload_attachment: "Upload attachment",
    generated_documents: "Generated Documents",
    preview: "Preview",
    preview_error: "Error generating preview: %{error}",
    scheduled_dispatch: "Scheduled Dispatch",
    scheduled_send: "Send Email(s)",
    day_before_event_start: "1 day before event start",
    day_after_event_end: "1 day after event end",
    scheduled_emails: "Scheduled Email |||| Scheduled Emails",
    waiting_list_confirmation: "Send confirmation for waiting list",
    contact_type: {
      invoice: "Billing addresses",
      communication: "Communication addresses",
    },
    parties: {
      recipient: "Recipient",
      attendee: "Attendee",
      invoice_recipient: "Invoice recipient",
    },
    show_recipient_addresses: "Show recipient address |||| Show %{smart_count} recipient addresses",
    cc_info: "A Cc is set for all e-mails (not just for a single one)",
    use_custom_email: "Enter a different email address",
    use_recipient_selection: "Use recipient selection",
    total_file_size_exceeded_warning: "The size limit for emails is 20 MB, including attachments and email content",
  },
  merging: {
    error: "Merging failed",
    merge_with: "Merge",
    person_to_merge: "Merge with",
    success: "Merging successful",
    login_warning: "The selected person has a login.",
    info: {
      title: "What happens when merging?",
      deletion_and_base_data:
        "The selected person will be deleted. Missing basic data (title, gender, date of birth, etc.) will be supplemented from the person being merged.",
      lecturer_and_attendee_data:
        "Attendee and lecturer properties (including custom fields) are fully transferred if the current user does not have that role. Otherwise, missing values are added.",
      contact_info_and_login:
        "The login is only transferred if the current person has no login. Contact information must be transferred manually if needed.",
      transferred_label: "Will be transferred:",
    },
  },
  invoice: {
    success: "Invoices were successfully created",
    error: "Error generating invoices",
    titles: {
      correction: "Correction to invoice [%{invoiceNumber}]",
      reversal: "Cancellation of invoice [%{invoiceNumber}]",
      standard: "Invoice",
    },
    correction_reversal: "Correction/Cancellation",
    success_delete: "Invoice was successfully deleted",
    error_delete: "Error deleting invoice",
    created_text:
      "The following invoices were successfully created and can be further processed using the actions below.",
    overview_text: "The following invoices can be further processed using the actions below.",
    send_to_accounting: "Transfer",
    selected_with_non_uniq_event: "The selected invoices must all belong to the same event",
  },
  show_detail_page: "Show detail page",
  export: {
    error: "Export failed",
    actions: {
      export: "Export",
      resource: "Export %{resource}",
      event: "Event",
      all_attendees: "Participants and bookings",
      all_lecturers: "Lecturers",
    },
    fields: {
      days: "Days",
      all_valid_bookings_count: "Attendance count",
    },
  },
  history: {
    action: {
      change: "changed",
      create: "added",
      delete: "removed",
      sent: "sent",
      sent_to: "sent to %{to}",
    },
    boolean_change: {
      is_bookable: {
        true: "made bookable",
        false: "made unbookable",
      },
      high_priority: {
        true: "pinned",
        false: "unpinned",
      },
      is_online: {
        true: "marked as online event",
        false: "marked as on-site event",
      },
      is_public: {
        true: "published",
        false: "made not public",
      },
    },
    special_change: "changed from %{oldValue} to %{newValue}",
    deleted: "deleted",
    deleted_f: "deleted",
    deleted_m: "deleted",
    deleted_n: "deleted",
    deleted_record: "Not found (likely deleted record): %{id}",
    fetch_error: "Could not load history",
    field_change: "%{name}: %{oldValue} → %{newValue}",
    value_change: "%{oldValue} → %{newValue}",
    no_value: "No value",
    archived: "Archived",
    restored: "Restored",
    show_all: "Show complete history",
  },
  permission_actions: {
    create: "Add",
    read: "View",
    update: "Edit",
    delete: "Delete",
    update_debit_number: "Update debit number",
  },
  feedback: {
    thank_you_headline: "Thank You",
    thank_you_description: "We would like to sincerely thank you for taking the time to fill out our feedback form.",
  },
  titles: {
    event_base_child_create: "Create offer for %{name}",
    registration_date: "Registration period",
    timespan: "Time Period",
  },
  actions: {
    remove_from_group: "Remove from group",
    remove_lecturer_from_event: "Remove from event",
    reset_filters: "Reset filters",
    select_all: "Select all",
    show_related_data: "Show related content",
    show_all: "Show all",
    show_all_errors: "%{smart_count} more error |||| %{smart_count} more errors",
    show_less: "Show less",
    send: "Send",
    edit_dashboard: "Edit Dashboard",
  },
  info_page: {
    software_version: "Software version",
    support: "Support",
    support_mail: "service@priorist.com",
    release_notes: "Release notes",
    release_notes_link: "https://education-manager.de/releases",
    license: "License notes",
    license_info:
      "EDM uses helpful third-party components and libraries. We are grateful to the authors of these products for making them available to the public. The following section contains the required license notes for third-party libraries included in EDM:",
    is_licensed_under: "is licensed under",
  },
  femCount: "One %{entity} is |||| %{count} %{entity} are",
  error: "Error",
  not: "Not",
  by: "by",
  to: "to",
  at: "at",
  connected_with: "connected with",
  disconnect: "disconnect",
  numbers: {
    2: "two",
    3: "three",
    4: "four",
    5: "five",
    6: "six",
    7: "seven",
    8: "eight",
    9: "nine",
    decimalSeparator: ".",
    thousandSeparator: ",",
  },
  more: "more",
  countMore: "%{count} more",
  less: "less",
  today: "Today",
  tomorrow: "Tomorrow",
  no_data: "No data available",
  reports: {
    title: "Evaluation",
    sales: "Sales",
    booking: "Booking |||| Bookings",
    sold_item: "Sold seat |||| Sold seats",
    calendar_week_with_date: "CW %{kw} starting %{date}",
    bookings_and_sales: "Sold seats and revenue",
    bookings_by_sales: "Sale prices by revenue",
    cancellation_by_events: "Cancellation Rate Events",
    event_status_chart: "Events by Status",
    report_by_base_data: "Master Data",
    total_occupancy: "Total Occupancy",
    draft: "Draft",
    offered: "Offer",
    takes_place: "Takes Place",
    finished: "Completed",
    canceled: "Cancelled",
    sales_with_amount: "EUR %{amount},- Sales",
    best_offers: "Top Offers",
    anchor: "Date",
    anchor_order_date: "Order date",
    anchor_event_date: "Event date",
    date_from: "From",
    date_to: "To",
    event_format: "Event Format",
    other: "Other |||| Others",
    states: "Evaluation by States",
    by_sales: "by Sales",
    by_bookings: "by sold seats",
    event_charts: "Evaluations",
    no_data_events: "No events available for this period",
    no_data_bookings: "No bookings available for this period",
    no_data_event_bases: "No offers booked for this period",
    metrics: {
      cancellation: "Cancellation||||Cancellations",
      events_carried_out: "Carried Out Event||||Carried Out Events",
      events_upcoming: "Upcoming Event||||Upcoming Events",
      average_price: "Average Price",
      wating_ratio: "Waiting List Ratio",
    },
  },
  dashboard: {
    title: "Dashboard",
    no_data_bookings: "No bookings available",
    bookings_overview: "Current Bookings",
    bookings_by_type: "Participation Overview",
    longest_waitinglist: "Longest Waiting List",
    registration_period_exceeded: "Registration Period Reached",
    booked_out: "Fully Booked",
    show_own: "Only Mine",
    empty_timeline: "No activities available",
    still_billable: "Still Billable",
    amount_open: "Open",
    amount_total: "Total Amount",
    few_bookings_necessary: "Only a few more bookings necessary",
    takes_place: "takes place",
    upcoming_events: "Upcoming Events",
    timespan: "Time Period",
    in_room: "in Room %{room}",
    more_lecturers: "... %{count} more",
    less_lecturers: "... less",
    valid: "Booked",
    waiting: "Waiting List",
    canceled: "Canceled",
    search_event: "Search event",
    recent_edited: "Recently edited",
    recent_orders: "Recent orders",
    filter: {
      today: "Today",
      yesterday: "Yesterday",
      next_seven_days: "Next 7 days",
      next_thirty_days: "Next 30 days",
      next_three_months: "Next 3 months",
      last_seven_days: "Last 7 days",
      last_thirty_days: "Last 30 days",
      current_month: "Current month",
      custom_range: "Custom range",
      last_three_months: "Last 3 months",
      last_six_months: "Last 6 months",
      this_year: "This year",
      last_year: "Last year",
      penultimate_year: "Penultimate year",
      remaining_year: "Remaining year",
    },
  },
  event_formats: {
    ONLINE: "Online",
    ONSITE: "Onsite",
    HYBRID: "Hybrid",
    E_LEARNING: "E-Learning",
  },
  attendance_formats: {
    ONLINE: "Online",
    ONSITE: "Onsite",
    HYBRID: "Hybrid",
  },
  email_scope_description: {
    NEW_MOODLE_ACCOUNT_TEMPLATE:
      "Automatically used when a user is linked to a Moodle account and a new Moodle account is created. Only one template can be assigned for this scope.",
    ENROLLMENT_APPROVAL_TEMPLATE:
      "Automatically used when a registration must be approved by an approver. Only one template can be assigned for this scope.",
    ENROLLMENT_DENIED_TEMPLATE:
      "Automatically used when a registration is rejected by an approver. Only one template can be assigned for this scope.",
    BOOKING_TEMPLATES: "Templates used in the context of bookings.",
    BOOKING_CONFIRMATION_TEMPLATES:
      "Templates for confirming successful bookings, e.g., during registration processing.",
    LECTURER_TEMPLATES: "Templates used for communication with lecturers.",
    CONSENT_TEMPLATES:
      "Templates used for consent-related processes, e.g., as part of a double opt-in procedure to obtain or confirm access permissions, such as portal access.",
    ENROLLMENT_CONFIRMATION_TEMPLATE:
      "Automatically sent after a successful registration (e.g., via the website) for an event. Only one template can be assigned for this scope.",
    FEEDBACK_TEMPLATES: "Templates used for sending feedback questionnaires.",
    NEW_ATTENDEE_TEMPLATE:
      "Automatically used when a login is assigned to a person or lecturer via the EDM interface. Only one template can be assigned for this scope.",
    NEW_STAFF_MEMBER_TEMPLATE:
      "Automatically used when a login is assigned to a staff member via the EDM interface. Only one template can be assigned for this scope.",
    ATTENDEE_TEMPLATES:
      "Templates used for communicating with persons. Important: these templates do not appear in the booking context, but only in the person context.",
    LECTURER_BOOKING_TEMPLATES: "Templates available in the lecturer portal, for communication with participants.",
    INVOICE_TEMPLATES: "Templates used in the context of invoicing.",
    PASSWORD_RESET_TEMPLATE:
      "Automatically used to send a password reset link. Only one template can be assigned for this scope.",
    ATTENDANCE_CONFIRMATION_TEMPLATES: "Templates used when sending attendance confirmations.",
    WAITING_LIST_TEMPLATES:
      "Templates used for confirming a waiting list booking, e.g., during registration processing.",
    ORDER_CONFIRMATION_TEMPLATE:
      "Automatically sent to the buyer when an order is received. Only one template can be assigned for this scope.",
    ORDER_ITEM_APPROVAL_TEMPLATE:
      "Automatically sent to request external approval for an order item. Only one template can be assigned for this scope.",
    ORDER_ITEM_DENIED_TEMPLATE:
      "Automatically sent when an order item's approval is denied. Only one template can be assigned for this scope.",
    ORDER_TEMPLATES: "Templates used in the context of orders, e.g. for emails to the ordering person or organization.",
    ORGANIZATION_TEMPLATES: "Templates used for communicating with organizations.",
    USER_TEMPLATES:
      "Templates used for communicating with persons. The attendee role and its custom fields are not available here; use the Attendee Templates scope for that.",
    BOOKING_CANCELLATION_REQUEST:
      "Automatically sent to the cancellation contact email from the settings when a person requests a cancellation in the portal. Cancellation requests are not possible without this template. Only one template can be assigned for this scope.",
    BOOKING_CANCELLATION_RECEIVED:
      "Automatically sent to the person who requested a cancellation, to acknowledge receipt of the request. Only one template can be assigned for this scope.",
    EVENT_LOCATION_TEMPLATES:
      "Templates usable for communication with event locations. Mails go to the location's email address.",
    INTEREST_TEMPLATES:
      "Templates for communicating with persons interested in an offering or event. No email is sent automatically when an interest comes in.",
  },
  permissions_description: {
    default:
      "Dashboard (without Still to be billed) / View events including bookings / View offers / View attendees / View interested people / View lecturers / Export records / View notes / View history",
    manage_events:
      "Create, edit, and archive events / Create, edit, and delete event dates / Create, edit, and delete event prices / Create, edit, and delete event documents / Create, edit, and delete event notes / Event functions (e.g., change status, duplicate, assign group, change offer)",
    manage_event_bases:
      "Create, edit, and archive offers / Create, edit, and delete offer descriptions / Create, edit, and delete offer documents / Create, edit, and delete offer notes / Offer functions (e.g., change offer type, duplicate)",
    manage_orders:
      "Create, confirm, cancel and process orders / Book and assign order items / Create order invoices / Email dispatch",
    manage_users:
      "Create, edit, and archive persons / Create, edit, and delete contact data / Create, edit, and delete tags",
    manage_attendees:
      "Create, edit, and archive attendees / Create, edit, and delete attendee contact data / Create, edit, and delete attendee documents / Create, edit, and delete attendee notes / Attendee functions (e.g., merge, create login) / Email dispatch",
    manage_interests: "Create, edit, and delete interested people",
    manage_lecturers:
      "Create, edit, and archive lecturers / Create, edit, and delete lecturer contact data / Create, edit, and delete lecturer documents / Create, edit, and delete lecturer notes / Lecturer functions (e.g., merge, create login) / Email dispatch",
    manage_todos_and_responsibilities:
      "Create, edit, and delete tasks within an event / Create, edit, and delete responsibilities within an event",
    manage_moodle:
      "Link, create, and delete Moodle courses / Link, create, and delete Moodle accounts / Create and delete Moodle enrollments",
    manage_bookings:
      "Create, edit, and delete bookings / Create, edit, and delete booking documents / View invoices / Email dispatch",
    manage_invoices:
      'Create, edit, and delete invoices (including correction and cancellation) / Send invoices / Display of "still to be billed" on dashboard',
    view_accounting: "View EDM accounting",
    view_reporting: "View evaluation",
    view_booking_list: "View booking list menu",
    view_invoice_list: "View invoice list menu",
    manage_accounting:
      "Transfer invoices (e.g. to ScopeVisio) / View and edit participant debtor numbers and event account fields / Mark bookings as paid",
    manage_access:
      "Create, edit, and archive employees / Create, edit, and delete permission groups / Create, edit, and delete OAuth applications",
    manage_templates:
      "Create, edit, and delete email templates / Create, edit, and delete email senders / Create, edit, and delete document templates / Create, edit, and delete responsibilities / Create, edit, and delete extended fields / Create, edit, and delete task lists",
    manage_settings:
      "Edit general settings / Create, edit, and delete price types / Create, edit, and delete environments / Create, edit, and delete offer types / Enable and disable linked applications",
    manage_base_data:
      "Create, edit, and delete event locations / Create, edit, and delete cooperation partners / Create, edit, and delete target groups / Create, edit, and delete categories / Create, edit, and delete keywords",
    manage_organizations: "Create, edit and delete organizations. Add people to organizations",
    manage_event_feedback: "Store feedback form for event / View event-specific feedback evaluation",
    view_feedback_report: "View general feedback evaluation",
  },
  portal: {
    welcome: "Welcome!",
    logged_in_as: "You are logged in as",
    your_bookings: "Your Bookings",
    your_orders: "Your orders",
    your_open_orders: "Open orders",
    your_interests: "Your personal favorites",
    your_events: "Your Events",
    your_organizations: "Your Organizations",
    create_organization: "Create organization",
    no_organizations: "No organization assigned yet.",
    show_past_bookings: "Past Bookings",
    show_past_events: "Past Events",
    event_canceled: "This event has been canceled",
    booking_waitinglist: "You are on the waiting list",
    booking_canceled: "This booking has been canceled",
    missing_consent:
      "Please note that you have not yet confirmed your email address. You can use the portal functions only after confirmation. If you have not received a verification email or need another one, please use the button below.",
    confirm_your_email: "Please confirm your email address",
    resend_verification_mail: "Resend verification email",
  },
  languages: {
    de: "German",
    en: "English",
    fr: "French",
    es: "Spanish",
  },
  admin: {
    descriptions: {
      event_locations: "Manage venues and rooms",
      partners: "Maintain partner information with descriptions",
      audiences: "Define target groups for offerings",
      categories: "Structure and manage topic categories",
      tags: "Create tags for search and filtering",
      user_lists: "Maintain and manage people and contact lists",

      staff_members: "Administer accounts and manage permissions",
      user_roles: "Define and assign access rights",
      o_auth_apps: "Register external apps and manage tokens",
      subscriptions: "Manage webhooks for different events",

      email_senders: "Configure sender profiles and signatures",
      external_email_templates: "Design and version standard emails",
      custom_field_content_types: "Model custom attributes",
      responsibility_types: "Assign responsibility by offer type",
      todo_lists: "Create and define checklist templates",
      document_templates: "Upload office layouts and set placeholders",
      invoice_templates: "Configure design incl. E-Rechnung",
      feedback_forms: "Design and manage questionnaires",

      settings: "Adjust global parameters and branding",
      event_types: "Define types with description fields",
      customer_invoices: "View Education Manager usage billing",
      customer: "Configure organization and contact data",
      price_types: "Maintain price variants and discounts",
      contexts: "Delimit your educational offerings",
      tax_rates: "Manage tax rates",
      integrated_applications: "View integrations",
      consent_types: "Maintain consent categories per GDPR",
      settings_general: "Configure general parameters, links and email settings",
      settings_portal: "Set up the participant portal and lecturer access",
      settings_defaults: "Define default values for new events",
      settings_storefront: "Customize the storefront configuration",
      settings_orders: "Configure order validation, checkout behavior and invoicing",
    },
  },
  mdx: {
    dialogControls: {
      save: "Save",
      cancel: "Cancel",
    },
    createLink: {
      url: "URL",
      urlPlaceholder: "Select or paste an URL",
      title: "Title",
      saveTooltip: "Set URL",
      cancelTooltip: "Cancel change",
    },
    linkPreview: {
      open: "Open {{url}} in new window",
      edit: "Edit link URL",
      copyToClipboard: "Copy to clipboard",
      copied: "Copied!",
      remove: "Remove link",
    },
    toolbar: {
      blockTypes: {
        paragraph: "Paragraph",
        quote: "Quote",
        heading: "Heading {{level}}",
      },
      blockTypeSelect: {
        selectBlockTypeTooltip: "Select block type",
        placeholder: "Block type",
      },
      toggleGroup: "toggle group",
      removeBold: "Remove bold",
      bold: "Bold",
      removeItalic: "Remove italic",
      italic: "Italic",
      underline: "Remove underline",
      removeUnderline: "Underline",
      removeInlineCode: "Remove code format",
      inlineCode: "Inline code format",
      link: "Create link",
      richText: "Rich text",
      diffMode: "Diff mode",
      source: "Source mode",
      admonition: "Insert Admonition",
      codeBlock: "Insert Code Block",
      editFrontmatter: "Edit frontmatter",
      insertFrontmatter: "Insert frontmatter",
      image: "Insert image",
      insertSandpack: "Insert Sandpack",
      table: "Insert Table",
      thematicBreak: "Insert thematic break",
      bulletedList: "Bulleted list",
      numberedList: "Numbered list",
      checkList: "Check list",
      deleteSandpack: "Delete this code block",
      undo: "Undo {{shortcut}}",
      redo: "Redo {{shortcut}}",
      highlight: "Highlight",
      removeHighlight: "Remove highlight",
    },
    contentArea: {
      editableMarkdown: "editable markdown",
    },
    parseError: "Failed to parse markdown content. The content may contain invalid formatting.",
  },
  event_date_planner: {
    series_toggle: "Add series",
    time_toggle: "Specify time",
    details_toggle: "Additional date details",
    no_existing_dates: "No dates available",
    existing_dates: "Show date |||| Show %{smart_count} dates",
    add_dates: "Add dates",
    already_planned:
      "%{smart_count} day already has a date and was skipped: %{days} |||| %{smart_count} days already have a date and were skipped: %{days}",
    save_planned_dates: "Save",
    remove_all_dates: "Remove all dates",
    planned_dates: "Add %{smart_count} date |||| Add %{smart_count} dates",
    every: "every",
    weeks: "week(s)",
    months: "month(s)",
    days: "day(s)",
    years: "year(s)",
    weekly: "Weekly",
    monthly: "Monthly",
    daily: "Daily",
    on: "Until",
    after: "After x times",
    single_date: "Single dates",
    rrule: {
      name: "Recurring dates",
      interval: "Interval",
      start: "Start",
      frequency: "Frequency",
      end_condition: "Ends",
      end_date: "End date",
      end_count: "Occurrences",
    },
    weekdays: {
      monday: "Mon",
      tuesday: "Tue",
      wednesday: "Wed",
      thursday: "Thu",
      friday: "Fri",
      saturday: "Sat",
      sunday: "Sun",
    },
  },
};

export default englishMessages;
